import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import makeAnimated from "react-select/animated";
import NotificationModal from "../../../components/NotificationModal";
import CustomConfirmModal from "../../../components/CustomConfirmModal";
import Select, { components, createFilter } from "react-select";
import CreatableSelect from "react-select/creatable";
import { Controller } from "react-hook-form";
// Google Places removed: avoid legacy SearchBox/Autocomplete warnings
import {
  useGetAllCompanySize,
  useGetAllIndications,
  useGetListForProviderTherapeutic,
  useGetProviderOrgDetails,
  UseGetRfiListForFilters,
  useProviderAffiliatedOrganization,
  useProviderCertifications,
  useProviderDiversityClassification,
  useProviderGeographicRegion,
  useProviderLanguages,
  useUpdateProviderOrg,
  useGetSponsorDetails,
  useUpdateSponsorUserDetails,
  useMakeRequestContact,
  useMakePrimaryContact,
  useActivateOrDeactivateProviderUserContact,
  useActivateOrDeactivateSponsorUserContact,
  useGetAllProviderOrg,
  useCreateProvider,
  useGetAllSponsorsForAdmin,
  useCreateProviderDualRoleFromProvider,
  useUpdateProviderUserRolesPermissionsForProvider,
  useGetProviderAllData,
  useGetSponsorsDetails,
  useGetAllProviderUsersByProviderId,
  useGetAllSponsorUserList,
} from "../../../custom-hooks/queries";
import { useVendorPreviewFullReportSetting } from "../../../custom-hooks/useVendorPreviewFullReportSetting";
import VendorPreviewFullReportSetting from "../../../components/OrgSettings/VendorPreviewFullReportSetting";
import {
  useVendorOrganizationLibraryCapabilities,
} from "../../../custom-hooks/useVendorProfileLibraryServices";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { customStyles, vendorRightsList, vendorTypeColors, vendorTypeOptions } from "../../../utils/constants";
import OrganizationUsersGrid from "../../../components/OrganizationUsersGrid";
import DatePickerController from "../../../components/datePickerController";
import {
  getUserType,
  twoWeeks,
  useUserRole,
  uploadFile,
} from "../../../utils/helperMethods";
import { useAccountManagementStats } from "../../../custom-hooks/useAccountManagementStats";
import { v4 as uuidv4 } from "uuid";
import {
  MagnifyingGlassIcon,
  ChevronUpDownIcon,
  ChevronDownIcon,
  CheckIcon,
} from "@heroicons/react/20/solid";
import {
  getCountryByValue,
  getStateOptions,
  parseAddressComponents,
} from "../../../utils/locationData";
import { VendorExpandableStats } from "../../../components/Provider/VendorExpandableStats";
import OrgLibraryDocumentsTab from "../../../components/OrgSettings/OrgLibraryDocumentsTab";
import Capabilities from "../../../components/Capabilities";
import {
  getProviderCapabilitiesList,
  resolveVendorProfileServiceCategories,
} from "../../../utils/vendorProfileCapabilities";
import {
  formatLocationCategoriesForForm,
  formatProviderCapabilitiesForForm,
  formatProviderCapabilitiesForPayload,
  toLocationRfiTemplateIds,
} from "../../../utils/vendorOrganizationServiceCategories";
import OrgNotificationsTab from "../../../components/OrgSettings/OrgNotificationsTab";
import {
  ActiveStatusCell,
  RequestContactBadge,
  formatCreatedDate,
} from "../../../components/UsersListTable";
import OrgTeamMembersPanel from "../../../components/OrgTeamMembersPanel";
import TableExportMenu from "../../../components/Menus/TableExportMenu";
import LocationFields from "../../../components/LocationFields";
import { XMarkIcon } from "@heroicons/react/24/outline";
import {
  PencilSquareIcon,
  NoSymbolIcon,
  CheckCircleIcon,
} from "@heroicons/react/24/outline";
import { findRfiColorMeta } from "../../../utils/serviceCategoriesColors";
import ServiceCategoryV2Dropdown from "../../../components/ServiceCategoryV2Dropdown";
import { useClerk, useUser } from "@clerk/clerk-react";
import {
  isLoggedInTeamMember,
  teamMemberRowClassName,
  resolveTeamMemberManagePath,
} from "../../../utils/teamMemberSelf";
import TeamMemberYouBadge from "../../../components/TeamMemberYouBadge";
import ActivateOrDeactivateConfirmationModal from "../../../components/ActivateOrDeactivateConfirmationModal";
import { getLocationFromProvider } from "../../../utils/addressUtils";
import {
  buildSponsorSettingsRootFields,
  buildSubscriptionInformationPatch,
  describeSettingsSaveResult,
  getOrgSubscriptionSettingsFromApi,
  isTurningVqaOnlyOff,
  settingsSaveErrorMessage,
} from "../../../utils/orgSubscriptionSettings";
import { canCreateVendorAccountFromSponsor } from "../../../utils/vendorAccountFromSponsor";
import OrgRiskEntitlementsSection from "../../../components/RFIsComponents/OrgRiskEntitlementsSection";
import { locationFieldsSchema, validateAdditionalLocations } from "../../../utils/locationFieldsValidation";
import { resolveReadOnlyOptionLabel } from "../../../utils/readOnlyFieldLabel";
import { UserDashboardStats } from "../../../components/Provider/UserDashboardStats";
import { getPortalAccessLabelFromSponsor, getPortalAccessLabelFromVendor } from "../../../utils/roles";
import {
  getActiveStatusLabel,
  getDiscoveryStatusLabel,
  mergeOrgStatusFromApi,
  shouldShowDiscoveryStatusBadge,
  shouldShowOrgStatusBadge,
} from "../../../utils/providerOrgStatus";
import {
  isCompanyEmailDisabled,
  mapCompanyEmailToProviderPayload,
} from "../../../utils/companyEmailField";
import {
  HttpsUrlInputStandalone,
  validateHttpsUrl,
} from "../../../components/HttpsUrlInput";
import {
  CONTACT_CATEGORY,
  getCategoryBadgeValue,
  alertRequestContactUpdateError,
} from "../../../utils/requestContactDesignations";
import { buildVendorContactMenuItems } from "../../../utils/vendorContactDesignationMenu";
import { debounce } from "lodash";
import { useUserTableFilters } from "../../../custom-hooks/useUserTableFilters";
import { useOrgTeamMembersSection } from "../../../custom-hooks/useOrgTeamMembersSection";
import { useTeamUsersFilterCatalog } from "../../../custom-hooks/useTeamUsersFilterCatalog";
import { nextTriStateSortConfig } from "../../../utils/teamUsersTable";
import { fetchOrgTeamUsersCatalogPage, resolveOrgTeamSize } from "../../../utils/teamUsersCatalog";
import { canOfferDeactivation } from "../../../utils/providerProfileMe";
import { sortConfigToVendorUserApiParams } from "../../../utils/vendorAdminGridSort";
import { sortConfigToSponsorUsersByOrgApiParams } from "../../../utils/sponsorUsersByOrgGridSort";

const NONE_SPONSOR_OPTION = {
  id: null,
  sponsor_id: null,
  hypercomply_org_id: null,
  name: "None (Create new vendor)",
  isNoneOption: true,
};

/** Matches FormInput `type="select"` (react-select) — indigo focus, gray border. */
const FORM_SINGLE_SELECT_STYLES = {
  ...customStyles,
  control: (base, state) => ({
    ...base,
    minHeight: "36px",
    borderRadius: "0.375rem",
    outline: "1px solid transparent",
    outlineOffset: "-1px",
    border: "none",
    boxShadow: state.isFocused
      ? "0 0 0 2px #4f46e5"
      : "inset 0 0 0 1px #d1d5db",
    paddingLeft: "12px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#9ca3af",
    marginLeft: 0,
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    color: "#111827",
  }),
  input: (base) => ({
    ...base,
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    margin: 0,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  valueContainer: (base) => ({
    ...base,
    padding: 0,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    paddingRight: "4px",
    paddingLeft: 0,
  }),
  menu: (base) => ({
    ...base,
    borderRadius: "0.375rem",
    boxShadow:
      "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
    border: "1px solid rgb(0 0 0 / 0.05)",
    padding: "4px 0",
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
    maxHeight: "384px",
  }),
  option: (base, state) => ({
    ...base,
    padding: "8px 12px",
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    backgroundColor:
      state.isFocused || state.isSelected ? "#4f46e5" : "white",
    color:
      state.isFocused || state.isSelected ? "white" : "#111827",
  }),
};

const initialActivateDeactivateModal = {
  open: false,
  kind: null,
  member: null,
  targetActive: null,
};

/** Single-select Company Type dropdown: search icon, chip with colored dot when selected, options with colored badges (prototype SingleSelectDropdown style) */
const CompanyTypeSelect = ({
  label,
  name,
  control,
  options = [],
  placeholder = "Company Type",
  required = false,
  showErrors = false,
  errors = {},
}) => {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const optionsWithColors = useMemo(
    () =>
      (options || []).map((opt) => {
        const o = typeof opt === "object" ? { value: opt.value, label: opt.label } : { value: opt, label: opt };
        return {
          ...o,
          dotColorClass: vendorTypeColors[o.label] || "bg-gray-400",
        };
      }),
    [options],
  );

  const filteredOptions = useMemo(
    () =>
      !query.trim()
        ? optionsWithColors
        : optionsWithColors.filter((option) =>
          option.label.toLowerCase().includes(query.toLowerCase()),
        ),
    [optionsWithColors, query],
  );

  const handleClickOutside = useCallback((event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
      setQuery("");
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [handleClickOutside]);

  return (
    <div className="flex flex-col">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          const selectedOption = optionsWithColors.find((o) => o.value === field.value) || null;
          return (
            <div className="relative" ref={dropdownRef}>
              <div
                className="relative w-full cursor-pointer rounded-md bg-white py-1.5 pl-3 pr-10 text-left outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600 sm:text-sm min-h-[40px] flex items-center"
                onClick={() => setIsOpen((prev) => !prev)}
              >
                <div className="flex items-center gap-2 min-h-[24px] flex-1 flex-wrap">
                  <MagnifyingGlassIcon className="h-4 w-4 text-gray-400 flex-shrink-0" />
                  {isOpen ? (
                    <input
                      type="text"
                      value={query}
                      onChange={(e) => setQuery(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                      placeholder={placeholder}
                      className="flex-1 min-w-[120px] border-0 bg-transparent p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 focus:outline-none text-sm"
                      autoFocus
                    />
                  ) : selectedOption ? (
                    <span className="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium leading-none ring-1 bg-white text-gray-900 ring-gray-200 ring-inset">
                      {selectedOption.dotColorClass && (
                        <span className={`inline-block w-2 h-2 rounded-full flex-shrink-0 ${selectedOption.dotColorClass}`} />
                      )}
                      {selectedOption.label}
                    </span>
                  ) : (
                    <span className="text-gray-400 text-sm">{placeholder}</span>
                  )}
                </div>
                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                  <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                </span>
              </div>

              {isOpen && (
                <div className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                  {filteredOptions.length === 0 ? (
                    <div className="px-3 py-2 text-gray-500">No results found</div>
                  ) : (
                    filteredOptions.map((option) => (
                      <div
                        key={option.value}
                        onClick={() => {
                          field.onChange(option.value);
                          setQuery("");
                          setIsOpen(false);
                        }}
                        className={`relative cursor-pointer select-none py-2 pl-3 pr-9 flex items-center gap-2 ${selectedOption?.value === option.value
                          ? "bg-indigo-600 text-white"
                          : "text-gray-900 hover:bg-indigo-600 hover:text-white"
                          }`}
                      >
                        {option.dotColorClass && (
                          <span className={`inline-block w-2 h-2 rounded-full flex-shrink-0 ${option.dotColorClass}`} />
                        )}
                        <span className={`flex-1 ${selectedOption?.value === option.value ? "font-semibold" : "font-normal"}`}>
                          {option.label}
                        </span>
                        {selectedOption?.value === option.value && (
                          <span className="flex items-center pr-2">
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        )}
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          );
        }}
      />
      {showErrors && errors[name] && (
        <p className="mt-1 text-sm text-red-600">{errors[name].message}</p>
      )}
    </div>
  );
};

/** Reusable form input component */
const FormInput = ({
  label,
  name,
  register,
  errors,
  placeholder,
  numeric,
  type = "text",
  options,
  disabled = false,
  className = "",
  required = false,
  control,
  watch,
  showErrors = false,
  privateInfoLabel,
}) => {
  if (type === "select") {
    // Use react-select styled like FormMultiSelect (same control, menu, options)
    return (
      <div className={`flex flex-col ${className}`}>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label} {required && <span className="text-red-600">*</span>}
          {privateInfoLabel && (
            <span className="ml-2 text-xs font-normal italic text-gray-500">
              This information is private to you.
            </span>
          )}
        </label>
        <Controller
          name={name}
          control={control}
          render={({ field }) => {
            const selectOptions = (options || []).map((opt) =>
              typeof opt === "object"
                ? { value: opt.value, label: opt.label }
                : { value: opt, label: opt },
            );

            const selected =
              selectOptions.find((o) => o.value === field.value) || null;

            return (
              <Select
                isClearable={false}
                isDisabled={disabled}
                options={selectOptions}
                styles={FORM_SINGLE_SELECT_STYLES}
                placeholder={placeholder || "Select..."}
                onChange={(val) => field.onChange(val ? val.value : null)}
                value={selected}
                noOptionsMessage={() => null}
                components={{
                  IndicatorSeparator: () => null,
                  ClearIndicator: () => null,
                  DropdownIndicator: (indicatorProps) => (
                    <components.DropdownIndicator {...indicatorProps}>
                      <ChevronUpDownIcon
                        className="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                    </components.DropdownIndicator>
                  ),
                }}
              />
            );
          }}
        />
        {showErrors && errors[name] && (
          <p className="mt-1 text-sm text-red-600">{errors[name].message}</p>
        )}
      </div>
    );
  }

  if (type === "textarea") {
    return (
      <div className={`flex flex-col ${className}`}>
        <label className="block text-sm font-medium text-gray-900">
          {label} {required && <span className="text-red-600">*</span>}
          {privateInfoLabel && (
            <span className="ml-2 text-xs font-normal italic text-gray-500">
              This information is private to you.
            </span>
          )}
        </label>
        <textarea
          {...register(name)}
          defaultValue={""}
          placeholder={placeholder}
          disabled={disabled}
          rows={4}
          className={`mt-1 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${disabled ? "bg-gray-100" : ""
            }`}
        />
        {showErrors && errors[name] && (
          <p className="mt-1 text-sm text-red-600">{errors[name].message}</p>
        )}
      </div>
    );
  }

  if (type === "radio") {
    return (
      <div className="flex flex-col">
        <label className="block text-sm font-medium text-gray-900">
          {label} {required && <span className="text-red-600">*</span>}
          {privateInfoLabel && (
            <span className="ml-2 text-xs font-normal italic text-gray-500">
              This information is private to you.
            </span>
          )}
        </label>
        <div className="flex items-center gap-6 mt-1">
          {options.map((val) => (
            <label key={val.name} className="flex items-center">
              <input
                type="radio"
                {...register(name, {
                  setValueAs: (value) => {
                    // Convert string "true"/"false" to actual boolean
                    if (value === "true") return true;
                    if (value === "false") return false;
                    return value;
                  },
                })}
                value={val.value.toString()}
                checked={
                  watch && watch(name)?.toString() === val.value.toString()
                }
                className="mr-2"
              />
              {val.name}
            </label>
          ))}
        </div>
        {showErrors && errors[name] && (
          <p className="mt-1 text-sm text-red-600">{errors[name].message}</p>
        )}
      </div>
    );
  }
  if (type === "date") {
    return (
      <div className={`flex flex-col ${className}`}>
        <label className="block text-sm font-medium text-gray-900">
          {label} {required && <span className="text-red-600">*</span>}
          {privateInfoLabel && (
            <span className="ml-2 text-xs font-normal italic text-gray-500">
              This information is private to you.
            </span>
          )}
        </label>
        <DatePickerController
          fieldName={name}
          control={control}
          minDate={twoWeeks}
        />
        {showErrors && errors[name] && (
          <p className="mt-1 text-sm text-red-600">{errors[name].message}</p>
        )}
      </div>
    );
  }

  if (type === "google-places") {
    // Render a plain registered input instead of Google Places components
    return (
      <div className={`flex flex-col ${className}`}>
        <label className="block text-sm font-medium text-gray-900">
          {label} {required && <span className="text-red-600">*</span>}
        </label>
        <input
          {...register(name)}
          defaultValue={""}
          type="text"
          placeholder={placeholder}
          disabled={disabled}
          className={`mt-1 w-full border-gray-300 rounded-md text-sm ${disabled ? "bg-gray-100" : ""
            }`}
        />
        {showErrors && errors[name] && (
          <p className="mt-1 text-sm text-red-600">{errors[name].message}</p>
        )}
      </div>
    );
  }

  return (
    <div className={`flex flex-col ${className}`}>
      <label className="block text-sm font-medium text-gray-900">
        {label} {required && <span className="text-red-600">*</span>}
        {privateInfoLabel && (
          <span className="ml-2 text-xs font-normal italic text-gray-500">
            This information is private to you.
          </span>
        )}
      </label>
      <input
        type={type}
        {...register(name)}
        defaultValue={""}
        placeholder={placeholder}
        disabled={disabled}
        onKeyPress={
          numeric
            ? (e) => {
              if (!/^[0-9]*$/.test(e.key)) e.preventDefault();
            }
            : undefined
        }
        className={`mt-1 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${disabled ? "bg-gray-100" : ""
          }`}
      />
      {showErrors && errors[name] && (
        <p className="mt-1 text-sm text-red-600">{errors[name].message}</p>
      )}
    </div>
  );
};

// Helper to render social icons
const SocialIcon = ({ name, url }) => {
  const baseClass = "h-5 w-5";
  const commonProps = { className: baseClass, fill: "currentColor" };
  const Icon = () => {
    switch (name) {
      case "linkedin_url":
        return (
          <svg {...commonProps} viewBox="0 0 24 24" aria-hidden>
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
          </svg>
        );
      case "facebook_url":
        return (
          <svg {...commonProps} viewBox="0 0 24 24" aria-hidden>
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
          </svg>
        );
      case "twitter_url":
        return (
          <svg {...commonProps} viewBox="0 0 24 24" aria-hidden>
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
          </svg>
        );
      case "instagram_url":
        return (
          <svg {...commonProps} viewBox="0 0 24 24" aria-hidden>
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.40s-.644-1.44-1.439-1.40z" />
          </svg>
        );
      case "youtube_url":
        return (
          <svg {...commonProps} viewBox="0 0 24 24" aria-hidden>
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
          </svg>
        );
      default:
        return (
          <svg {...commonProps} viewBox="0 0 24 24" aria-hidden>
            <circle cx="12" cy="12" r="10" />
          </svg>
        );
    }
  };

  return url ? (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      aria-label={name}
      title={name}
      className="text-slate-400 hover:text-slate-600"
    >
      <Icon />
    </a>
  ) : (
    <span
      aria-label={name}
      title={name}
      className="text-slate-400 hover:text-slate-600"
    >
      <Icon />
    </span>
  );
};

// Small TagInput used for creatable multi fields to match prototype
const TagInput = ({ placeholder = "", onAdd }) => {
  const [value, setValue] = useState("");

  const commit = () => {
    const v = (value || "").trim();
    if (!v) return;
    onAdd(v);
    setValue("");
  };

  return (
    <input
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === "," || e.key === "Tab") {
          e.preventDefault();
          commit();
        }
      }}
      onBlur={() => commit()}
      placeholder={""}
      className="flex-1 min-w-[120px] min-h-[24px] text-sm outline-none border-none px-0 py-0 bg-transparent text-gray-900 placeholder-transparent"
    />
  );
};

/** Reusable multi-select component */

const FormMultiSelect = ({
  label,
  name,
  control,
  options,
  required = false,
  conditionallyRequired = false,
  isCreatable = false,
  className = "",
  watchFn,
  showErrors = false,
  colorize = false,
  placeholder,
}) => {
  const animatedComponents = makeAnimated();
  const SelectComponent = isCreatable ? CreatableSelect : Select;

  // rfisColors from redux to colorize badges when needed
  const rfisState = useSelector((state) => state.rfisColors);
  const rfisList = rfisState?.rfis || [];

  // Access watch from parent form context passed as prop
  // Make sure watchFn exists before using it
  let formWatch = false;

  if (watchFn) {
    if (name === "service_categories_secondary_location") {
      const secondaryAddress = watchFn("secondary_address");
      formWatch =
        secondaryAddress &&
        secondaryAddress.trim &&
        secondaryAddress.trim() !== "";
    } else if (name === "service_categories_additional_locations") {
      const addLocations = watchFn("additional_locations");
      const numLocations = parseInt(
        watchFn("number_of_additional_locations") || 0,
        10,
      );
      formWatch =
        (addLocations && addLocations.trim && addLocations.trim() !== "") ||
        (!isNaN(numLocations) && numLocations > 0);
    }
  }

  const isFieldRequired = required || (conditionallyRequired && formWatch);

  return (
    <div className={`flex flex-col ${className}`}>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {isFieldRequired && <span className="text-red-600">*</span>}
      </label>

      <Controller
        name={name}
        control={control}
        rules={{
          required: isFieldRequired ? `${label} is required` : false,
        }}
        render={({ field, fieldState: { error } }) => (
          <>
            {isCreatable ? (
              <div className="w-full">
                <div className="flex flex-wrap items-center gap-1 w-full rounded-md bg-white py-1.5 pl-3 pr-10 min-h-[24px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600 sm:text-sm">
                  {(field.value || []).map((item, idx) => {
                    const label = (item && (item.label || item.value)) || item;
                    return (
                      <span
                        key={`${label}-${idx}`}
                        className="inline-flex items-center bg-white border border-gray-200 text-gray-800 text-xs font-medium rounded-md px-2 py-0.5 mr-2 mb-1"
                        style={{
                          boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.03)",
                        }}
                      >
                        <span className="mr-2">{label}</span>
                        <button
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            const newVal = (field.value || []).filter(
                              (v, i) => i !== idx,
                            );
                            field.onChange(newVal);
                          }}
                          className="inline-flex items-center justify-center flex-shrink-0 -mr-1 h-3.5 w-3.5 rounded-sm hover:bg-gray-500/20 text-gray-600"
                          aria-label={`Remove ${label}`}
                        >
                          <svg viewBox="0 0 14 14" className="h-3.5 w-3.5 stroke-current pointer-events-none" aria-hidden="true">
                            <path d="M4 4l6 6m0-6l-6 6" />
                          </svg>
                        </button>
                      </span>
                    );
                  })}

                  <TagInput
                    placeholder={placeholder}
                    onAdd={(val) => {
                      if (!val || !val.trim()) return;
                      const normalized = val.trim();
                      const existing = (field.value || []).map((v) =>
                        v && v.label ? v.label : v,
                      );
                      if (existing.includes(normalized)) return;
                      const newItem = { value: normalized, label: normalized };
                      field.onChange([...(field.value || []), newItem]);
                    }}
                  />
                </div>
              </div>
            ) : (
              <SelectComponent
                {...field}
                isMulti
                options={options}
                closeMenuOnSelect={false}
                components={{
                  IndicatorSeparator: () => null,
                  ClearIndicator: () => null,
                  DropdownIndicator: (indicatorProps) => (
                    <components.DropdownIndicator {...indicatorProps}>
                      <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </components.DropdownIndicator>
                  ),
                  MultiValue: colorize
                    ? ({ data, innerProps, removeProps }) => {
                      const label = data.label || data.value || "";
                      const meta = findRfiColorMeta(data, rfisList) || {};
                      return (
                        <div
                          {...innerProps}
                          style={{
                            backgroundColor: meta.bg || "#eaeaea",
                            color: meta.text || "#111",
                            boxShadow: meta.border
                              ? `inset 0 0 0 1px ${meta.border}1A`
                              : undefined,
                          }}
                          className="inline-flex items-center rounded-md px-2 py-1 text-xs font-semibold mr-2 mb-1 gap-1.5"
                        >
                          <span>{label}</span>
                          <button
                            type="button"
                            className="inline-flex items-center justify-center flex-shrink-0 -mr-1 h-3.5 w-3.5 rounded-sm hover:bg-gray-500/20 text-gray-600"
                            aria-label={`Remove ${label}`}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              if (removeProps?.onMouseDown) removeProps.onMouseDown(e);
                            }}
                            onTouchEnd={(e) => {
                              if (removeProps?.onTouchEnd) removeProps.onTouchEnd(e);
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (removeProps?.onClick) removeProps.onClick(e);
                            }}
                          >
                            <svg viewBox="0 0 14 14" className="h-3.5 w-3.5 stroke-current pointer-events-none" aria-hidden="true">
                              <path d="M4 4l6 6m0-6l-6 6" />
                            </svg>
                          </button>
                        </div>
                      );
                    }
                    : ({ data, innerProps, removeProps }) => {
                      const label = data.label || data.value || "";
                      return (
                        <span
                          {...innerProps}
                          className="inline-flex items-center bg-white border border-gray-200 text-gray-800 text-xs font-medium rounded-md px-2 py-0.5 mr-2 mb-1 gap-1.5"
                          style={{
                            boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.03)",
                          }}
                        >
                          <span>{label}</span>
                          <button
                            type="button"
                            className="inline-flex items-center justify-center flex-shrink-0 -mr-1 h-3.5 w-3.5 rounded-sm hover:bg-gray-500/20 text-gray-600"
                            aria-label={`Remove ${label}`}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              if (removeProps?.onMouseDown) removeProps.onMouseDown(e);
                            }}
                            onTouchEnd={(e) => {
                              if (removeProps?.onTouchEnd) removeProps.onTouchEnd(e);
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (removeProps?.onClick) removeProps.onClick(e);
                            }}
                          >
                            <svg viewBox="0 0 14 14" className="h-3.5 w-3.5 stroke-current pointer-events-none" aria-hidden="true">
                              <path d="M4 4l6 6m0-6l-6 6" />
                            </svg>
                          </button>
                        </span>
                      );
                    },
                }}
                placeholder={placeholder}
                styles={{
                  ...customStyles,
                  control: (base, state) => ({
                    ...base,
                    minHeight: "40px",
                    borderRadius: "0.375rem",
                    outline: "1px solid transparent",
                    outlineOffset: "-1px",
                    border: "none",
                    boxShadow: state.isFocused
                      ? "0 0 0 2px #4f46e5"
                      : "inset 0 0 0 1px #d1d5db",
                    paddingLeft: "12px",
                    paddingRight: "0px",
                    paddingTop: "6px",
                    paddingBottom: "6px",
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    padding: 0,
                    gap: "4px",
                    flexWrap: "wrap",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#9ca3af",
                    marginLeft: 0,
                    fontSize: "0.875rem",
                    lineHeight: "1.25rem",
                  }),
                  multiValue: (base) => ({
                    ...base,
                    margin: 0,
                    padding: 0,
                    borderRadius: 0,
                    backgroundColor: "transparent",
                    border: "none",
                  }),
                  multiValueLabel: (base) => ({
                    ...base,
                    padding: 0,
                    display: "none",
                  }),
                  multiValueRemove: (base) => ({
                    ...base,
                    display: "none",
                  }),
                  indicatorsContainer: (base) => ({
                    ...base,
                    paddingRight: "4px",
                    paddingLeft: 0,
                  }),
                  menu: (base) => ({
                    ...base,
                    borderRadius: "0.375rem",
                    boxShadow:
                      "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
                    border: "1px solid rgb(0 0 0 / 0.05)",
                    padding: "4px 0",
                  }),
                  menuList: (base) => ({
                    ...base,
                    padding: 0,
                    maxHeight: "384px",
                  }),
                  option: (base, state) => ({
                    ...base,
                    padding: "8px 12px",
                    fontSize: "0.875rem",
                    lineHeight: "1.25rem",
                    backgroundColor:
                      state.isFocused || state.isSelected
                        ? "#4f46e5"
                        : "white",
                    color:
                      state.isFocused || state.isSelected ? "white" : "#111827",
                  }),
                }}
                noOptionsMessage={() => null} // No dropdown unless creating
                onChange={(selected) => field.onChange(selected)}
                value={field.value}
              />
            )}
            {showErrors && error && (
              <p className="text-red-600 text-xs mt-1">{error.message}</p>
            )}
          </>
        )}
      />
    </div>
  );
};

const getSponsorFormValues = (sponsor = {}) => ({
  name: sponsor.sponsor_name ?? sponsor.name ?? "",
  email: sponsor.company_email ?? sponsor.email ?? "",
  url: sponsor.website ?? sponsor.url ?? "",
  phone_number: sponsor.office_number ?? sponsor.phone_number ?? "",
  company_type: sponsor.company_type ?? "",
  street_address: sponsor.address1 ?? sponsor.street_address ?? "",
  city: sponsor.city ?? "",
  state: sponsor.state ?? "",
  country: sponsor.country ?? "",
  zip: sponsor.zip_code ?? sponsor.zip ?? "",
  primaryAddress: sponsor.address1 ?? sponsor.street_address ?? "",
  primaryCity: sponsor.city ?? "",
  primaryState: sponsor.state ?? "",
  primaryCountry: sponsor.country ?? "",
});

const VendorOrganizationForm = ({
  type = "vendor",
  mode = "manage",
  showTeamTab = true,
  onCreateSubmit,
  provisionalProviderId,
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const pathParams = useParams();
  const tab = searchParams.get("tab");
  const userRole = useUserRole();
  const { user } = useUser();
  const { session } = useClerk();
  const subRoles = user?.publicMetadata?.sub_role || [];
  const currentUserType = getUserType(userRole, subRoles) || "vendor";
  const vendorId =
    searchParams.get("vendorId") ||
    (type === "vendor" ? pathParams?.id : null) ||
    (currentUserType === "vendor" ? user?.publicMetadata?.provider_id : null);
  const sponsorId =
    searchParams.get("sponsorId") ||
    (type === "sponsor" ? pathParams?.id : null) ||
    (currentUserType === "sponsor" ? user?.publicMetadata?.sponsor_id : null);
  const {
    data: providerData,
    isLoading: isLoadingDetails,
    isSuccess: isDataLoaded,
    refetch: refetchUserDetails,
  } = useGetProviderOrgDetails(vendorId);
  const {
    data: sponsorData,
    isLoading: isLoadingSponsorDetailsData,
    isSuccess: isDataLoadedSponsorDetailsData,
    refetch: refetchSponsorDetails,
  } = useGetSponsorDetails(sponsorId);

  const isVendorView = currentUserType === "vendor" || (currentUserType === "admin" && type === "vendor");
  const isSponsorView = currentUserType === "sponsor" || (currentUserType === "admin" && type === "sponsor");
  const isAdmin = currentUserType === "admin";
  const previewFullReport = useVendorPreviewFullReportSetting(
    vendorId,
    isVendorView && mode !== "create"
  );

  const tabs = (() => {
    const base = showTeamTab
      ? [
          { name: "Company Profile", key: "overview" },
          { name: "Team", key: "users" },
        ]
      : [{ name: "Company Profile", key: "overview" }];
    if (mode !== "create") {
      base.push({ name: "Library Documents", key: "documents" });
    }
    // Sponsor-only tab: visible to sponsor users and to admins viewing a sponsor org.
    // Never shown to vendors or on a vendor org screen.
    if (isSponsorView && !isVendorView && !!sponsorId && mode !== "create") {
      base.push({ name: "Notifications", key: "notifications" });
    }
    if (isAdmin && mode !== "create") {
      base.push({ name: "Settings", key: "settings" });
    }
    return base;
  })();

  const prefilledTab = tabs?.find((t) => t.key === tab)?.key ?? "overview";
  const logoInputRef = useRef(null);
  const [activeTab, setActiveTab] = useState(prefilledTab);
  const [isEditMode, setIsEditMode] = useState(mode === "create");
  const {
    filters: teamUserFilters,
    setFilters: setTeamUserFilters,
    defaultFilters: defaultTeamUserFilters,
    handleFilterChange: handleTeamUserFilterChange,
    handleClearFilters: handleClearTeamUserFilters,
    hasFilterChanges: hasTeamUserFilterChanges,
  } = useUserTableFilters(isVendorView);
  const [teamSearchTerm, setTeamSearchTerm] = useState("");
  const [debouncedTeamSearchTerm, setDebouncedTeamSearchTerm] = useState("");
  const [usersCurrentPage, setUsersCurrentPage] = useState(1);
  const [isTeamSearchExpanded, setIsTeamSearchExpanded] = useState(false);
  const [teamSortConfig, setTeamSortConfig] = useState({});
  const teamSearchInputRef = useRef(null);
  const debouncedSetTeamSearch = useMemo(
    () =>
      debounce((value) => {
        setDebouncedTeamSearchTerm(value);
      }, 300),
    []
  );
  useEffect(() => () => debouncedSetTeamSearch.cancel(), [debouncedSetTeamSearch]);
  const [activateDeactivateModal, setActivateDeactivateModal] = useState(initialActivateDeactivateModal);

  const {
    data: diversityClassificationData,
    isLoading: isDiversityClassificationLoading,
    isError: isDiversityClassificationError,
  } = useProviderDiversityClassification();

  const isUpdateMode =
    mode === "create" ? false : !!vendorId || !!sponsorId; // create flow: new vendor/sponsor
  const { data: companySize } = useGetAllCompanySize();

  const optionsForCompanySize = companySize?.map((item) => ({
    value: item.id,
    label: item.range,
  }));

  // State for multi-step form
  const [lastSavedValues, setLastSavedValues] = useState(null);

  // Google Places autocomplete state
  const [autocomplete, setAutocomplete] = useState(null);
  const [autocompleteSecondary, setAutocompleteSecondary] = useState(null);
  const [autocompleteAdditional, setAutocompleteAdditional] = useState(null);
  const [coordinates, setCoordinates] = useState({ lat: null, lng: null });
  const [primaryAddress, setPrimaryAddress] = useState("");
  const [primaryCity, setPrimaryCity] = useState("");
  const [primaryCountry, setPrimaryCountry] = useState("");
  const [primaryState, setPrimaryState] = useState("");
  const [additionalLocationsList, setAdditionalLocationsList] = useState([]);
  const [additionalAutocompleteInstances, setAdditionalAutocompleteInstances] =
    useState([]);
  const [primaryCountrySearch, setPrimaryCountrySearch] = useState("");
  const [primaryStateSearch, setPrimaryStateSearch] = useState("");
  const [isPrimaryCountryDropdownOpen, setIsPrimaryCountryDropdownOpen] =
    useState(false);
  const [isPrimaryStateDropdownOpen, setIsPrimaryStateDropdownOpen] =
    useState(false);

  const teamUserSortOptions = useMemo(
    () =>
      isVendorView
        ? sortConfigToVendorUserApiParams(teamSortConfig)
        : sortConfigToSponsorUsersByOrgApiParams(teamSortConfig),
    [isVendorView, teamSortConfig]
  );
  const { data: vendorUsersData, isLoading: isLoadingVendorUsers } =
    useGetAllProviderUsersByProviderId(
      isVendorView ? vendorId : null,
      21,
      usersCurrentPage,
      debouncedTeamSearchTerm,
      isVendorView ? teamUserSortOptions : undefined,
      teamUserFilters
    );
  const { data: sponsorUsersData, isLoading: isLoadingSponsorUsers } =
    useGetAllSponsorUserList({
      currentPage: usersCurrentPage,
      id: isSponsorView ? sponsorId : null,
      search_text: debouncedTeamSearchTerm,
      page_size: 21,
      sortOptions: isSponsorView ? teamUserSortOptions : undefined,
      filters: teamUserFilters,
    });

  const usersList = useMemo(
    () =>
      isVendorView
        ? (vendorUsersData?.items ?? [])
        : (sponsorUsersData?.items ?? []),
    [isVendorView, sponsorUsersData, vendorUsersData]
  );
  const usersSummary = isVendorView ? vendorUsersData : sponsorUsersData;
  const isLoadingTeamUsers = isVendorView ? isLoadingVendorUsers : isLoadingSponsorUsers;

  const fetchTeamCatalogPage = useCallback(
    (page) =>
      fetchOrgTeamUsersCatalogPage(
        { isVendorView, vendorId, sponsorId },
        page
      ),
    [isVendorView, sponsorId, vendorId]
  );
  const {
    catalogItems,
    totalUsers: teamCatalogTotalUsers,
    catalogQuery: teamCatalogQuery,
  } = useTeamUsersFilterCatalog({
    queryKey: [
      "orgTeamUsersCatalog",
      isVendorView ? "vendor" : "sponsor",
      isVendorView ? vendorId : sponsorId,
    ],
    fetchPage: fetchTeamCatalogPage,
    enabled: Boolean(isVendorView ? vendorId : sponsorId) && mode !== "create",
  });

  const currentOrg = sponsorData ?? providerData;
  const { data: providerOrgData } = useGetAllProviderOrg(1, 1, currentOrg?.email ?? "");
  const dualRoleOrg = providerOrgData?.items?.[0] ?? null;
  const {
    teamUserFilterDefinitions,
    getTeamUsersExportData,
    handleAddTeamMember,
    emptyDescription: teamUsersEmptyDescription,
  } = useOrgTeamMembersSection({
    isVendorView,
    isSponsorView,
    currentUserType,
    vendorId,
    sponsorId,
    providerData,
    sponsorData,
    dualRoleOrg,
    catalogItems,
    teamUserFilters,
    hasTeamUserFilterChanges,
    debouncedTeamSearchTerm,
    teamUserSortOptions,
    navigate,
  });

  const handleTeamSort = useCallback((key) => {
    setTeamSortConfig((prev) => nextTriStateSortConfig(prev, key));
    setUsersCurrentPage(1);
  }, []);

  const { mutate: mutateMakeRequestContact } = useMakeRequestContact();
  const { mutate: mutateMakePrimaryContact } = useMakePrimaryContact();
  const { mutate: mutateActivateOrDeactivateProviderUserContact } = useActivateOrDeactivateProviderUserContact();
  const { mutate: mutateActivateOrDeactivateSponsorUserContact } = useActivateOrDeactivateSponsorUserContact();

  useEffect(() => {
    setTeamUserFilters(defaultTeamUserFilters);
  }, [defaultTeamUserFilters]);

  useEffect(() => setUsersCurrentPage(1), [debouncedTeamSearchTerm, teamUserFilters]);

  const teamMemberColumns = useMemo(
    () => [
      {
        key: "name",
        header: "Name",
        sortable: true,
        cellClassName: "text-gray-700",
        render: (row) => {
          const isMe = isLoggedInTeamMember(row, user?.id, { isVendorView });
          return (
            <span className="inline-flex items-center gap-2">
              <span>
                {row.first_name} {row.last_name}
              </span>
              {isMe && <TeamMemberYouBadge />}
            </span>
          );
        },
      },
      {
        key: "title",
        header: "Title",
        sortable: true,
        cellClassName: "text-gray-700",
        render: (row) => row.job_title || row.title || "—",
      },
      {
        key: "email",
        header: "Email",
        sortable: true,
        cellClassName: "text-gray-700",
        render: (row) => row.email,
      },
      {
        key: "is_active",
        header: "Active Status",
        sortable: true,
        render: (row) => (
          <ActiveStatusCell
            isActive={row.is_active}
            isInvited={row.has_joined === false}
            lastActivityAt={row.last_login_datetime || row.last_login_at}
          />
        ),
      },
      {
        key: "role",
        header: "Role",
        sortable: true,
        cellClassName: "text-gray-700",
        render: (row) =>
          row?.sponsor_subrole_dto?.[0]?.sub_role ?? row?.role ?? "—",
      },
      {
        key: "portal_access",
        header: "Portal Access",
        sortable: true,
        cellClassName: "text-gray-700",
        render: (row) => isVendorView ? getPortalAccessLabelFromVendor(row, dualRoleOrg) : getPortalAccessLabelFromSponsor(row, dualRoleOrg) || "—",
      },
      {
        key: "vqq_contact",
        header: "VQQ Contact",
        sortable: false,
        showItem: isVendorView,
        render: (row) => (
          <RequestContactBadge
            value={getCategoryBadgeValue(row, CONTACT_CATEGORY.RFI)}
            variant="vqq"
          />
        ),
      },
      {
        key: "assessment_contact",
        header: "Assessment Contact",
        sortable: false,
        showItem: isVendorView,
        render: (row) => (
          <RequestContactBadge
            value={getCategoryBadgeValue(row, CONTACT_CATEGORY.ASSESSMENT)}
            variant="assessment"
          />
        ),
      },
      {
        key: "created_at",
        header: "Created",
        sortable: true,
        cellClassName: "text-gray-700",
        render: (row) => formatCreatedDate(row.created_at ?? row.created_date ?? row.create_date_time),
      },
    ],
    [dualRoleOrg, isVendorView, user?.id]
  );

  const handleManageTeamMember = useCallback((member) => {
    const url = resolveTeamMemberManagePath({
      member,
      clerkUserId: user?.id,
      isVendorView,
      isSponsorView,
      currentUserType,
      sponsorData,
      providerData,
    });
    if (url) navigate(url);
  }, [navigate, sponsorData, currentUserType, isVendorView, isSponsorView, providerData, user?.id]);

  const handleToggleCategoryRequestContact = useCallback((member, category, status) => {
    if (!member?.provider_user_id) return;
    mutateMakeRequestContact(
      { provider_user_id: member.provider_user_id, request_contact_status: status, category },
      { onError: alertRequestContactUpdateError }
    );
  }, [mutateMakeRequestContact]);

  const handleCategoryPrimaryContact = useCallback((member, category) => {
    if (!member?.provider_user_id) return;
    const primaryField =
      category === CONTACT_CATEGORY.RFI ? "rfi_is_primary" : "assessment_is_primary";
    if (member[primaryField]) return;
    mutateMakePrimaryContact({
      provider_id: vendorId,
      provider_user_id: member.provider_user_id,
      category,
    });
  }, [mutateMakePrimaryContact, vendorId]);

  const handleActivateOrDeactivateContact = useCallback((id, isActive) => {
    if (!id) return;
    if (isVendorView) {
      mutateActivateOrDeactivateProviderUserContact({ provider_user_id: id, is_active: isActive });
    } else if (isSponsorView) {
      mutateActivateOrDeactivateSponsorUserContact({ sponsor_user_id: id, is_active: isActive });
    }
  }, [mutateActivateOrDeactivateProviderUserContact, mutateActivateOrDeactivateSponsorUserContact, isVendorView, isSponsorView]);

  const openActivateDeactivateContactModal = useCallback(
    (member, targetActive) => {
      if (isVendorView && !member?.provider_user_clerk_id) return;
      if (isSponsorView && !member?.id) return;
      setActivateDeactivateModal({
        open: true,
        kind: isVendorView ? "providerUser" : "sponsorUser",
        member,
        targetActive,
      });
    },
    [isVendorView, isSponsorView]
  );

  const handleActivateContact = useCallback(
    (member) => {
      openActivateDeactivateContactModal(member, true);
    },
    [openActivateDeactivateContactModal]
  );

  const handleDeactivateContact = useCallback(
    (member) => {
      openActivateDeactivateContactModal(member, false);
    },
    [openActivateDeactivateContactModal]
  );

  const handleConfirmActivateDeactivateContact = useCallback(() => {
    const { kind, member, targetActive } = activateDeactivateModal;
    if (!member || targetActive == null) return;
    const id =
      kind === "providerUser"
        ? member.provider_user_clerk_id
        : kind === "sponsorUser"
          ? member.id
          : null;
    if (id == null) return;
    handleActivateOrDeactivateContact(id, targetActive);
    setActivateDeactivateModal(initialActivateDeactivateModal);
  }, [activateDeactivateModal, handleActivateOrDeactivateContact]);

  const closeActivateDeactivateModal = useCallback(() => {
    setActivateDeactivateModal(initialActivateDeactivateModal);
  }, []);

  const activateDeactivateContactEntityName = useMemo(() => {
    const member = activateDeactivateModal.member;
    if (!member) return "";
    const full = [member.first_name, member.last_name].filter(Boolean).join(" ").trim();
    return full || member.email || "—";
  }, [activateDeactivateModal.member]);

  const teamMemberActionMenuItems = useMemo(
    () => [
      {
        label: (row) => {
          const isMe = isLoggedInTeamMember(row, user?.id, { isVendorView });
          return isMe ? "Manage my profile" : "Manage";
        },
        icon: <PencilSquareIcon className="h-5 w-5" />,
        onClick: handleManageTeamMember,
      },
      ...buildVendorContactMenuItems({
        allUsers: usersList,
        onToggleRequestContact: handleToggleCategoryRequestContact,
        onMakePrimary: handleCategoryPrimaryContact,
        showItem: isVendorView,
      }),
      {
        label: "Deactivate Contact",
        icon: <NoSymbolIcon className="h-5 w-5" />,
        onClick: handleDeactivateContact,
        showItem: (item) =>
          canOfferDeactivation(item, {
            isSelf: isLoggedInTeamMember(item, user?.id, { isVendorView }),
            orgCatalogItems: teamCatalogQuery?.isSuccess ? catalogItems : null,
          }),
      },
      {
        label: "Activate Contact",
        icon: <CheckCircleIcon className="h-5 w-5" />,
        onClick: handleActivateContact,
        showItem: (item) => !item.is_active,
      },
    ],
    [
      handleManageTeamMember,
      handleToggleCategoryRequestContact,
      handleCategoryPrimaryContact,
      handleDeactivateContact,
      handleActivateContact,
      usersList,
      isVendorView,
      user?.id,
      catalogItems,
      teamCatalogQuery?.isSuccess,
    ]
  );

  // Google Places autocomplete handlers
  const handleOnLoadSecondary = (autocompleteInstance) => {
    setAutocompleteSecondary(autocompleteInstance);
  };

  const handleOnLoadAdditional = (autocompleteInstance) => {
    setAutocompleteAdditional(autocompleteInstance);
  };

  const rfisState = useSelector((state) => state.rfisColors);
  const rfisList = rfisState?.rfis || [];

  const { mutate: updateVendor } = useUpdateProviderOrg();
  const { mutate: updateSponsor } = useUpdateSponsorUserDetails();
  const { mutate: createProvider } = useCreateProvider();
  const { mutate: createProviderDualRole } =
    useCreateProviderDualRoleFromProvider();
  const { mutateAsync: updateProviderUserRolesAsync } =
    useUpdateProviderUserRolesPermissionsForProvider();

  const { data: sponsorsData, isLoading: isLoadingSponsors } =
    useGetAllSponsorsForAdmin({
      current_page: 1,
      page_size: 1000,
    }, mode === "create");

  const sponsorsOptions = useMemo(() => {
    let sponsors = [];
    if (sponsorsData?.items && Array.isArray(sponsorsData.items)) {
      sponsors = sponsorsData.items;
    } else if (Array.isArray(sponsorsData)) {
      sponsors = sponsorsData;
    } else if (sponsorsData?.data && Array.isArray(sponsorsData.data)) {
      sponsors = sponsorsData.data;
    }
    if (!sponsors || sponsors.length === 0) {
      return [];
    }
    return sponsors
      .filter(canCreateVendorAccountFromSponsor)
      .map((sponsor) => {
        const sid = sponsor.sponsor_id;
        const sname = sponsor.sponsor_name || "";
        return {
          id: sid,
          name: sname,
          value: sid,
          label: sname,
          sponsor_id: sid,
          sponsor_name: sname,
          hypercomply_org_id: sponsor.hypercomply_org_id,
          ...sponsor,
        };
      });
  }, [sponsorsData]);

  const sponsorSelectOptions = useMemo(() => {
    const noneOpt = {
      value: "__none__",
      label: "None (Create new vendor)",
      data: NONE_SPONSOR_OPTION,
    };
    const rest = (sponsorsOptions || []).map((s) => ({
      value: s.sponsor_id,
      label: s.sponsor_name || s.name || "",
      data: s,
    }));
    return [noneOpt, ...rest];
  }, [sponsorsOptions]);

  const { stats: statsData, statsDetails: statsDetailsData, isLoading: isLoadingStatsData } =
    useAccountManagementStats({
      teamSize: resolveOrgTeamSize({
        isVendorView,
        catalogItems,
        isCatalogLoaded: teamCatalogQuery?.isSuccess === true,
        catalogTotalUsers: teamCatalogTotalUsers,
        tableTotalUsers: usersSummary?.total_items,
      }),
      teamSummary: usersSummary,
      userId: sponsorId ?? vendorId,
      userType: currentUserType,
      isVendorView,
      isSponsorView,
      enabled: mode !== "create",
    });

  const stats = statsData;
  const statsDetails = statsDetailsData;
  const isLoadingStats = isLoadingStatsData;

  const [isUploadingLogo, setIsUploadingLogo] = useState(false);
  const [isSettingsEditMode, setIsSettingsEditMode] = useState(false);
  const [settingsSnapshot, setSettingsSnapshot] = useState(null);
  const [isSettingsSaving, setIsSettingsSaving] = useState(false);
  const [orgData, setOrgData] = useState({
    name: currentOrg?.name,
    logo: currentOrg?.logo?.includes('?')
      ? currentOrg?.logo?.split('?')[0]
      : currentOrg?.logo || null,
    ...mergeOrgStatusFromApi(currentOrg),
    ...getOrgSubscriptionSettingsFromApi(currentOrg),
  });
  useEffect(() => {
    if (currentOrg) {
      setOrgData((prev) => ({
        ...prev,
        name: currentOrg.name || currentOrg?.sponsor_name || prev.name,
        logo: currentOrg.logo?.includes('?')
          ? currentOrg.logo?.split('?')[0]
          : currentOrg.logo || prev.logo || null,
        ...mergeOrgStatusFromApi(currentOrg, prev),
        ...getOrgSubscriptionSettingsFromApi(currentOrg),
      }));
    }
  }, [currentOrg]);

  // handleOnLoad / handlePlaceChanged defined after useForm (need setValue for display sync)

  const handleCancelEdit = () => {
    if (mode === "create") {
      navigate("/Backend/Users/Vendors");
      return;
    }
    if (lastSavedValues) {
      reset(lastSavedValues);
      setPrimaryAddress(
        lastSavedValues.street_address || lastSavedValues.primaryAddress || "",
      );
      setPrimaryCity(lastSavedValues.city || lastSavedValues.primaryCity || "");
      setPrimaryState(
        lastSavedValues.state || lastSavedValues.primaryState || "",
      );
      setPrimaryCountry(
        lastSavedValues.country || lastSavedValues.primaryCountry || "",
      );
    }
    setIsEditMode(false);
    setFormSubmitted(false);
  };

  const syncPrimaryLocationFormValues = () => {
    setValue("primaryAddress", primaryAddress ?? "", { shouldValidate: false });
    setValue("primaryCity", primaryCity ?? "", { shouldValidate: false });
    setValue("primaryState", primaryState ?? "", { shouldValidate: false });
    setValue("primaryCountry", primaryCountry ?? "", { shouldValidate: false });
  };

  const runAdditionalLocationValidation = () =>
    validateAdditionalLocations(additionalLocationsList, {
      setError,
      clearErrors,
    });

  const handleSave = () => {
    setFormSubmitted(true);
    syncPrimaryLocationFormValues();
    // Trigger form submission; onSubmit handles create/update
    handleSubmit(
      (data) => {
        if (!runAdditionalLocationValidation()) return;
        onSubmit(data);
      },
      (errors) => {
        runAdditionalLocationValidation();
        setFormSubmitted(true);
        console.error("Validation errors:", errors);
      },
    )();
  };

  const createEmptyAdditionalLocation = () => ({
    address: "",
    city: "",
    state: "",
    country: "",
    zip: "",
    location_type: "additional",
  });

  const mapProviderLocationToAdditional = (loc) => ({
    address: loc?.address || loc?.address1 || "",
    city: loc?.city || "",
    state: loc?.state || "",
    country: loc?.country || "",
    zip: loc?.zip || "",
    location_type: loc?.location_type || "additional",
  });

  const normalizeProviderLocations = (locations) =>
    (Array.isArray(locations) ? locations : []).filter(Boolean);

  const getNonPrimaryProviderLocations = (locations) =>
    normalizeProviderLocations(locations).filter(
      (loc) => loc?.location_type !== "primary",
    );

  // Additional locations handlers — additionalLocationsList is the source of truth
  const handleAddAdditionalLocation = () => {
    setAdditionalLocationsList((prev) => [
      ...normalizeProviderLocations(prev),
      createEmptyAdditionalLocation(),
    ]);
  };

  const handleRemoveAdditionalLocation = (index) => {
    setAdditionalLocationsList((prev) =>
      normalizeProviderLocations(prev).filter((_, i) => i !== index),
    );
    clearErrors(`additional_${index}_Address`);
    clearErrors(`additional_${index}_City`);
    clearErrors(`additional_${index}_State`);
    clearErrors(`additional_${index}_Country`);
  };

  const handleUpdateAdditionalLocation = (index, updated) => {
    setAdditionalLocationsList((prev) =>
      normalizeProviderLocations(prev).map((item, i) =>
        i === index
          ? {
              ...item,
              ...updated,
              location_type: item?.location_type || "additional",
            }
          : item,
      ),
    );
    if (updated?.address !== undefined) {
      setValue(`additional_${index}_Address`, updated.address ?? "");
    }
    if (updated?.city !== undefined) {
      setValue(`additional_${index}_City`, updated.city ?? "");
    }
    if (updated?.state !== undefined) {
      setValue(`additional_${index}_State`, updated.state ?? "");
    }
    if (updated?.country !== undefined) {
      setValue(`additional_${index}_Country`, updated.country ?? "");
    }
  };

  // Support per-additional Autocomplete instances (store by index)
  const handleOnLoadAdditionalAtIndex = (instance, index) => {
    setAdditionalAutocompleteInstances((prev) => {
      const next = [...prev];
      next[index] = instance;
      return next;
    });
  };

  const handlePlaceChangedAdditionalAtIndex = (index) => {
    const ac = additionalAutocompleteInstances[index];
    if (!ac) return;
    const place = ac.getPlace();
    const { streetAddress, city, state, countryCode } =
      parseAddressComponents(place);
    handleUpdateAdditionalLocation(index, {
      address: streetAddress,
      city,
      state,
      country: countryCode,
    });
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.type !== "image/png") {
      alert("Only .png files are supported for logo uploads.");
      return;
    }
    const uploadEntityId =
      (isVendorView ? vendorId : sponsorId) ||
      provisionalProviderId ||
      uuidv4();
    const uniqueName = `${uuidv4()}.png`;
    const fileToUpload = new File([file], uniqueName, { type: file.type });
    setIsUploadingLogo(true);
    try {
      const imageUrl = await uploadFile(fileToUpload, uploadEntityId, isVendorView ? "providers" : "sponsors");
      if (imageUrl) {
        const logo = imageUrl?.split('?')[0] || null;
        setOrgData((prev) => ({ ...prev, logo }));
        if (mode === "create" || (!vendorId && !sponsorId)) {
          return;
        }
        if (isVendorView) {
          updateVendor({ id: vendorId, providerData: { ...getVendorData(getValues()), logo } });
        } else {
          updateSponsor({ id: sponsorId, userData: { ...getSponsorData(getValues()), logo } });
        }
      }
    } finally {
      setIsUploadingLogo(false);
    }
  };


  // Schema remains the same
  const vendorSchema = yup.object().shape({
    sponsor_organization: yup.mixed().nullable(),

    number_of_additional_locations: yup
      .number()
      .nullable()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? null : value,
      ),

    are_service_categories_same_across_locations: yup
      .boolean()
      .nullable()
      .when(["additional_locations", "number_of_additional_locations"], {
        is: (addLocations, numLocations) =>
          (addLocations && addLocations.trim && addLocations.trim() !== "") ||
          (numLocations && parseInt(numLocations, 10) > 0),
        then: (schema) =>
          schema.required("Required if additional locations are inputted"),
        otherwise: (schema) => schema.nullable(),
      }),

    name: yup.string().required("Vendor name is required"),
    url: yup
      .string()
      .test({
        name: "is-valid-https-url",
        test(value) {
          const r = validateHttpsUrl(value);
          if (r.valid) return true;
          return this.createError({ message: r.message });
        },
      })
      .required("Website URL is required"),

    linkedin_url: yup
      .string()
      .nullable()
      .test({
        name: "is-valid-https-url",
        test(value) {
          const r = validateHttpsUrl(value);
          if (r.valid) return true;
          return this.createError({ message: r.message });
        },
      }),
    facebook_url: yup
      .string()
      .nullable()
      .test({
        name: "is-valid-https-url",
        test(value) {
          const r = validateHttpsUrl(value);
          if (r.valid) return true;
          return this.createError({ message: r.message });
        },
      }),
    twitter_url: yup
      .string()
      .nullable()
      .test({
        name: "is-valid-https-url",
        test(value) {
          const r = validateHttpsUrl(value);
          if (r.valid) return true;
          return this.createError({ message: r.message });
        },
      }),
    instagram_url: yup
      .string()
      .nullable()
      .test({
        name: "is-valid-https-url",
        test(value) {
          const r = validateHttpsUrl(value);
          if (r.valid) return true;
          return this.createError({ message: r.message });
        },
      }),
    youtube_url: yup
      .string()
      .nullable()
      .test({
        name: "is-valid-https-url",
        test(value) {
          const r = validateHttpsUrl(value);
          if (r.valid) return true;
          return this.createError({ message: r.message });
        },
      }),
    provider_type: yup.string().nullable(),
    company_type: yup.string().nullable(),
    description: yup.string().nullable(),
    employee_range_id: yup.string().nullable(),
    year_founded: yup
      .number()
      .nullable()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? null : value,
      ),
    annual_revenue_usd: yup
      .string()
      .nullable()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? null : value,
      ),

    // address1: yup.string().required("Street is required"),
    city: yup.string(),
    street_address: yup.string(),
    state: yup.string(),
    country: yup.string(),
    // Primary location always required (visible fields; state only when country has states)
    ...locationFieldsSchema("primary", { mode: "always" }),
    other_address: yup.string().nullable(),
    additional_locations: yup.string().nullable(),
    // phone_number: yup.string().required("Phone number is required"),
    landline_num: yup.string().nullable(),

    // first_name: yup.string().required("First name is required"),
    email: yup
      .string()
      .email("Enter a valid email")
      .required("Email is required"),

    pa_signed: yup.boolean().nullable(),
    is_platform_ready: yup.boolean().nullable(),

    are_additional_locations_available: yup
      .boolean()
      .nullable()
      .when("additional_locations", {
        is: (val) => val && val.trim() !== "",
        then: (schema) =>
          schema.required(
            "This field is required when additional locations are added",
          ),
        otherwise: (schema) => schema.nullable(),
      }),
    additional_locations_count: yup
      .number()
      .nullable()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? null : value,
      ),

    first_invite_sent: yup
      .object({
        startDate: yup
          .date()
          .nullable()
          .typeError("First invite date must be valid"),
      })
      .nullable(),
    last_invite_sent: yup
      .object({
        startDate: yup
          .date()
          .nullable()
          .typeError("Last invite date must be valid"),
      })
      .nullable(),
    pa_signed_date: yup
      .object({
        startDate: yup
          .date()
          .nullable()
          .typeError("PA signed date must be valid"),
      })
      .nullable(),
    pa_expiration_date: yup
      .object({
        startDate: yup
          .date()
          .nullable()
          .typeError("PA expiration date must be valid"),
      })
      .nullable(),

    invited_by: yup.string().nullable(),
    number_of_sponsors_served: yup
      .number()
      .nullable()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? null : value,
      ),
    number_of_subsidiaries: yup
      .number()
      .nullable()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? null : value,
      ),
    rfi_count: yup
      .number()
      .nullable()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? null : value,
      ),
    assessment_count: yup
      .number()
      .nullable()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? null : value,
      ),

    is_legacy_account: yup.boolean(),

    ticker: yup.string().nullable(),
    pharma_sponsors_served: yup.string().nullable(),
    locations_quality_management_system: yup.string().nullable(),

    status: yup.string().nullable(),
    comments: yup.string().nullable(),
    provider_file_name: yup.string().nullable(),

    // ✅ Multi-select Fields
    provider_capabilities: yup
      .array()
      .min(1, "Please select at least one service category")
      .required("Service Categories are required"),

    provider_therapeutic_areas: yup.array().nullable(),

    provider_indications: yup.array().nullable(),

    provider_other_capabilities: yup.array().nullable(),
    provider_certifications: yup.array().nullable(),
    provider_other_certifications: yup.array().nullable(),

    provider_diversity_classifications: yup.array().nullable(),
    provider_geographic_regions: yup.array().nullable(),
    provider_service_compliance_types: yup.array().nullable(),
    provider_languages: yup.array().nullable(),
    provider_affiliated_organizations: yup.array().nullable(),

    provider_locations: yup.array().nullable(),
  });


  const sponsorSchema = yup.object().shape({
    name: yup.string().required("Sponsor name is required"),
    email: yup.string().email("Enter a valid email").required("Email is required"),
    url: yup
      .string()
      .test({
        name: "is-valid-https-url",
        test(value) {
          const r = validateHttpsUrl(value);
          if (r.valid) return true;
          return this.createError({ message: r.message });
        },
      })
      .required("Website URL is required"),
    phone_number: yup.string().required("Phone number is required"),
    company_type: yup.string().required("Company type is required"),
    street_address: yup.string(),
    city: yup.string(),
    state: yup.string(),
    country: yup.string(),
    // Primary location always required (visible fields; state only when country has states)
    ...locationFieldsSchema("primary", { mode: "always" }),
    zip: yup.string().default(""),
  });

  const schema = isVendorView ? vendorSchema : sponsorSchema;

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty, isValid },
    reset,
    setValue,
    watch,
    control,
    trigger,
    clearErrors,
    setError,
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      sponsor_organization: null,
      additional_locations: "",
      are_additional_locations_available: null,
      are_service_categories_same_across_locations: null,
    },
    mode: "onChange", // Changed to onChange to validate as user types
  });
  const {
    libraryDocuments,
    lockedValues: libraryLockedValues,
    lockedLabels: libraryLockedLabels,
    mergeSelected: mergeLibrarySelected,
  } = useVendorOrganizationLibraryCapabilities({
    vendorId,
    enabled: isVendorView && mode !== "create",
    getValues,
    setValue,
  });
  // Store the form methods for use in validation
  const methods = { trigger, clearErrors, setValue, setError };

  // Keep read-only view fields (street_address, city, …) in sync with LocationFields state
  const syncPrimaryLocationDisplayFields = useCallback(
    ({ address, city, state, country, zip } = {}) => {
      const street = address ?? primaryAddress ?? "";
      const cityVal = city ?? primaryCity ?? "";
      const stateVal = state ?? primaryState ?? "";
      const countryVal = country ?? primaryCountry ?? "";

      setValue("street_address", street, { shouldDirty: false });
      setValue("city", cityVal, { shouldDirty: false });
      setValue("state", stateVal, { shouldDirty: false });
      setValue("country", countryVal, { shouldDirty: false });
      setValue("primaryAddress", street, { shouldDirty: false });
      setValue("primaryCity", cityVal, { shouldDirty: false });
      setValue("primaryState", stateVal, { shouldDirty: false });
      setValue("primaryCountry", countryVal, { shouldDirty: false });
      if (zip !== undefined) {
        setValue("zip", zip, { shouldDirty: false });
      }

      try {
        const formatted = getLocationFromProvider(
          {
            address1: street,
            city: cityVal,
            state: stateVal,
            country: countryVal,
          },
          { short: false, abbvState: true },
        );
        setValue("primaryLocation", formatted || "", { shouldDirty: false });
      } catch (e) {
        setValue("primaryLocation", "", { shouldDirty: false });
      }
    },
    [primaryAddress, primaryCity, primaryState, primaryCountry, setValue],
  );

  const handleOnLoad = useCallback(
    (autocompleteInstance) => setAutocomplete(autocompleteInstance),
    [],
  );

  const handlePlaceChanged = useCallback(() => {
    if (!autocomplete) return;
    const place = autocomplete.getPlace();
    const { streetAddress, city, state, countryCode } =
      parseAddressComponents(place);
    setPrimaryAddress(streetAddress);
    setPrimaryCity(city);
    setPrimaryState(state);
    setPrimaryCountry(countryCode);
    syncPrimaryLocationDisplayFields({
      address: streetAddress,
      city,
      state,
      country: countryCode,
    });
  }, [autocomplete, syncPrimaryLocationDisplayFields]);

  const finalizeProfileSave = useCallback(
    async (savedLocation = {}) => {
      syncPrimaryLocationDisplayFields(savedLocation);
      setLastSavedValues(getValues());
      if (isVendorView && typeof refetchUserDetails === "function") {
        await refetchUserDetails();
      }
      if (isSponsorView && typeof refetchSponsorDetails === "function") {
        await refetchSponsorDetails();
      }
    },
    [
      syncPrimaryLocationDisplayFields,
      getValues,
      isVendorView,
      isSponsorView,
      refetchUserDetails,
      refetchSponsorDetails,
    ],
  );

  // Notification modal state
  const [alertOpen, setAlertOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  // Track if form has been submitted to show errors
  const [formSubmitted, setFormSubmitted] = useState(false);

  // Organization Settings tab: edit/save (notification state declared above)
  const handleSettingsEdit = useCallback(() => {
    setSettingsSnapshot({
      mfa_required_for_org: orgData.mfa_required_for_org,
      is_vqa_only: orgData.is_vqa_only,
      trial_experience_enabled: orgData.trial_experience_enabled,
      chat_diligent_enabled: orgData.chat_diligent_enabled,
      has_auto_score: orgData.has_auto_score,
      auto_score_quota: orgData.auto_score_quota,
      auto_score_unlimited: orgData.auto_score_unlimited,
      has_sme_score: orgData.has_sme_score,
      sme_score_quota: orgData.sme_score_quota,
      sme_score_unlimited: orgData.sme_score_unlimited,
    });
    setIsSettingsEditMode(true);
  }, [
    orgData.mfa_required_for_org,
    orgData.is_vqa_only,
    orgData.trial_experience_enabled,
    orgData.chat_diligent_enabled,
    orgData.has_auto_score,
    orgData.auto_score_quota,
    orgData.auto_score_unlimited,
    orgData.has_sme_score,
    orgData.sme_score_quota,
    orgData.sme_score_unlimited,
  ]);

  const handleSettingsCancel = useCallback(() => {
    if (settingsSnapshot) {
      setOrgData((prev) => ({
        ...prev,
        ...settingsSnapshot,
      }));
    }
    setSettingsSnapshot(null);
    setIsSettingsEditMode(false);
    previewFullReport.reset();
  }, [settingsSnapshot, previewFullReport]);

  // TODO: Verify backend propagates `mfa_required_for_org` to Clerk (`publicMetadata.org_mfa_enabled`
  // or legacy `org_mfa_required` per end-user) when admin saves Settings.
  const [isConfirmingVqaOnlyOff, setIsConfirmingVqaOnlyOff] = useState(false);

  const saveSettings = useCallback(() => {
    if (mode === "create") return;
    setIsSettingsSaving(true);
    if (sponsorId && isSponsorView) {
      updateSponsor(
        {
          id: sponsorId,
          userData: {
            ...getSponsorData(getValues()),
            ...buildSponsorSettingsRootFields(orgData),
            subscription_information: buildSubscriptionInformationPatch(
              currentOrg,
              orgData,
            ),
          },
        },
        {
          onSuccess: async (result) => {
            if (session) {
              await session.reload();
            }
            const outcome = describeSettingsSaveResult(result);
            setIsSettingsSaving(false);
            setIsSettingsEditMode(false);
            setSettingsSnapshot(null);
            setIsSuccess(outcome.isSuccess);
            setMessage(outcome.message);
            setAlertOpen(true);
            if (typeof refetchSponsorDetails === "function") {
              refetchSponsorDetails();
            }
          },
          onError: (error) => {
            setIsSettingsSaving(false);
            setIsSuccess(false);
            setMessage(settingsSaveErrorMessage(error));
            setAlertOpen(true);
          },
        },
      );
      return;
    }
    if (vendorId && isVendorView) {
      const afterPreviewFlag = () =>
      updateVendor(
        {
          id: vendorId,
          providerData: {
            ...getVendorData(getValues()),
            mfa_required_for_org: !!orgData.mfa_required_for_org,
            subscription_information: buildSubscriptionInformationPatch(
              currentOrg,
              orgData,
              { includeFeatureFlags: false },
            ),
          },
        },
        {
          onSuccess: async () => {
            if (session) {
              await session.reload();
            }
            setIsSettingsSaving(false);
            setIsSettingsEditMode(false);
            setSettingsSnapshot(null);
            setIsSuccess(true);
            setMessage("Organization settings saved successfully.");
            setAlertOpen(true);
            if (typeof refetchUserDetails === "function") {
              refetchUserDetails();
            }
          },
          onError: (error) => {
            setIsSettingsSaving(false);
            setIsSuccess(false);
            setMessage(error?.message || "Error saving organization settings.");
            setAlertOpen(true);
          },
        },
      );
      (previewFullReport.isReady ? previewFullReport.save() : Promise.resolve())
        .then(afterPreviewFlag)
        .catch((error) => {
          setIsSettingsSaving(false);
          setIsSuccess(false);
          setMessage(error?.message || "Error saving organization settings.");
          setAlertOpen(true);
        });
      return;
    }
    setIsSettingsSaving(false);
  }, [
    mode,
    sponsorId,
    vendorId,
    isSponsorView,
    isVendorView,
    orgData,
    currentOrg,
    updateSponsor,
    updateVendor,
    refetchSponsorDetails,
    refetchUserDetails,
    session,
    previewFullReport,
    getValues,
  ]);

  // Switching a VQA only org back creates its HyperComply accounts, so the admin confirms it first.
  const handleSettingsSave = useCallback(() => {
    if (isSponsorView && isTurningVqaOnlyOff(currentOrg, orgData)) {
      setIsConfirmingVqaOnlyOff(true);
      return;
    }
    saveSettings();
  }, [isSponsorView, currentOrg, orgData, saveSettings]);

  // State for managing selected users and their roles (for sponsor dual role)
  const [selectedUsersWithRoles, setSelectedUsersWithRoles] = useState([]);

  const selectedSponsorOrg = watch("sponsor_organization");
  const selectedSponsorIdDual =
    selectedSponsorOrg?.sponsor_id || selectedSponsorOrg?.value;
  const selectedSponsorOrgIdDual = selectedSponsorOrg?.hypercomply_org_id;

  const { data: sponsorDetailsData, isLoading: isLoadingSponsorDetails } =
    useGetSponsorsDetails(selectedSponsorIdDual, selectedSponsorOrgIdDual);

  const {
    data: providerAllData,
    isLoading: isLoadingProviderUsers,
    isError: isErrorProviderUsers,
  } = useGetProviderAllData(selectedSponsorIdDual);

  const providerDetailsWithUsers = useMemo(() => {
    if (!providerAllData?.users || !Array.isArray(providerAllData.users)) {
      return null;
    }
    const contacts = providerAllData.users?.filter(user => !user.isdual_role).map((user) => ({
      contactId: user.sponsor_user_id || user.sponser_clerk_id || uuidv4(),
      firstName: user.first_name || "",
      lastName: user.last_name || "",
      email: user.email || "",
      phone: user.landline_number || "",
      phoneNumber: user.landline_number || "",
      officePhoneNumber: user.landline_number || "",
      isOwner: user.is_owner || false,
      user_clerk_id: user.sponser_clerk_id || null,
      userClerkId: user.sponser_clerk_id || null,
      user_clerk: user.sponser_clerk_id || null,
      org_id: user.hc_org_id || selectedSponsorOrgIdDual,
      subRoles: user.sub_role ? [user.sub_role] : [],
      role: user.role || "",
    }));
    return {
      contacts,
      providerId: selectedSponsorIdDual,
    };
  }, [providerAllData, selectedSponsorIdDual, selectedSponsorOrgIdDual]);

  const formNameWatch = watch("name");
  useEffect(() => {
    if (mode === "create" && formNameWatch) {
      setOrgData((prev) => ({ ...prev, name: formNameWatch }));
    }
  }, [mode, formNameWatch]);

  useEffect(() => {
    if (mode !== "create" || !sponsorDetailsData || !selectedSponsorIdDual) {
      return;
    }
    setValue("name", sponsorDetailsData.sponsorName || "", {
      shouldValidate: true,
    });
    setValue("email", sponsorDetailsData.companyEmail || "", {
      shouldValidate: true,
    });
    setValue("url", sponsorDetailsData.website || "", {
      shouldValidate: true,
    });
    setValue("landline_num", sponsorDetailsData.officeNumber || "", {
      shouldValidate: true,
    });
    setValue("phone_number", sponsorDetailsData.officeNumber || "", {
      shouldValidate: true,
    });

    const street =
      sponsorDetailsData.address1 ??
      sponsorDetailsData.address ??
      sponsorDetailsData.streetAddress ??
      "";
    const cityVal = sponsorDetailsData.city || "";
    const countryVal = sponsorDetailsData.country ?? "";
    const stateVal = sponsorDetailsData.state ?? "";
    const zipVal =
      sponsorDetailsData.zip_code ?? sponsorDetailsData.zip ?? "";

    setValue("city", cityVal, {
      shouldValidate: true,
    });
    setValue("state", stateVal, {
      shouldValidate: true,
    });
    setValue("country", countryVal, {
      shouldValidate: true,
    });
    setValue("street_address", street, { shouldValidate: true });
    setValue("zip", zipVal, { shouldValidate: true });

    try {
      const formatted = getLocationFromProvider(
        {
          address1: street,
          city: cityVal,
          state: stateVal,
          country: countryVal,
        },
        { short: false, abbvState: true },
      );
      setValue("primaryLocation", formatted || "");
    } catch (e) {
      setValue(
        "primaryLocation",
        getLocationFromProvider(
          {
            address: street,
            city: cityVal,
            state: stateVal,
            country: countryVal,
          },
          { short: false, abbvState: true },
        ),
      );
    }

    setPrimaryAddress(street);
    setPrimaryCity(cityVal);
    setPrimaryState(stateVal);
    setPrimaryCountry(countryVal);
    setValue("primaryAddress", street);
    setValue("primaryCity", cityVal);
    setValue("primaryState", stateVal);
    setValue("primaryCountry", countryVal);

    const logoCandidate = selectedSponsorOrg.logo ?? null;
    let logoNormalized = null;
    if (logoCandidate && String(logoCandidate).trim()) {
      const s = String(logoCandidate).trim();
      logoNormalized = s.includes("?") ? s.split("?")[0] : s;
    }
    setOrgData((prev) => ({ ...prev, logo: logoNormalized }));
  }, [mode, sponsorDetailsData, selectedSponsorOrg, selectedSponsorIdDual, setValue]);

  useEffect(() => {
    if (
      !sponsorData ||
      !sponsorId ||
      !isUpdateMode ||
      !isDataLoadedSponsorDetailsData
    ) {
      return;
    }

    const sponsorValues = getSponsorFormValues(sponsorData);
    let primaryLocation = "";
    try {
      primaryLocation = getFormattedLocation({
        address1: sponsorValues.primaryAddress,
        city: sponsorValues.primaryCity,
        state: sponsorValues.primaryState,
        country: sponsorValues.primaryCountry,
      });
    } catch {
      // Keep the individual location fields available even if formatting a
      // malformed legacy address fails.
    }
    const hydratedValues = {
      ...getValues(),
      ...sponsorValues,
      primaryLocation: primaryLocation || "",
    };

    // Hydrate atomically so the read-only view never exposes a partially
    // populated sponsor profile while individual fields are being updated.
    reset(hydratedValues);
    setLastSavedValues(hydratedValues);
    setPrimaryAddress(sponsorValues.primaryAddress);
    setPrimaryCity(sponsorValues.primaryCity);
    setPrimaryState(sponsorValues.primaryState);
    setPrimaryCountry(sponsorValues.primaryCountry);
  }, [
    sponsorData,
    sponsorId,
    isUpdateMode,
    isDataLoadedSponsorDetailsData,
    getValues,
    reset,
  ]);

  // Handle role change for users
  const handleUserRoleChange = (userId, role) => {
    setSelectedUsersWithRoles((prev) => {
      // If role is null, remove the user from selection
      if (role === null) {
        return prev.filter((u) => u.userId !== userId);
      }

      const existingIndex = prev.findIndex((u) => u.userId === userId);
      if (existingIndex >= 0) {
        const updated = [...prev];
        updated[existingIndex] = { userId, role };
        return updated;
      }
      return [...prev, { userId, role }];
    });
  };

  // Clear all sponsor-populated fields when "None" is selected or sponsor is cleared
  const clearSponsorFields = () => {
    setValue("name", "", { shouldDirty: false });
    setValue("email", "", { shouldDirty: false });
    setValue("url", "", { shouldDirty: false });
    setValue("landline_num", "", { shouldDirty: false });
    setValue("phone_number", "", { shouldDirty: false });
    setValue("city", "", { shouldDirty: false });
    setValue("state", "", { shouldDirty: false });
    setValue("country", "", { shouldDirty: false });
    setValue("street_address", "", { shouldDirty: false });
    setValue("zip", "", { shouldDirty: false });
    setValue("primaryLocation", "", { shouldDirty: false });
    setValue("primaryAddress", "", { shouldDirty: false });
    setValue("primaryCity", "", { shouldDirty: false });
    setValue("primaryState", "", { shouldDirty: false });
    setValue("primaryCountry", "", { shouldDirty: false });
    setPrimaryAddress("");
    setPrimaryCity("");
    setPrimaryState("");
    setPrimaryCountry("");
    setSelectedUsersWithRoles([]);
    setOrgData((prev) => ({ ...prev, logo: null }));
  };

  const { data: rfis } = UseGetRfiListForFilters();
  const { data: threupatic } = useGetAllIndications();
  const { data: therapeutics } = useGetListForProviderTherapeutic();

  const getFormattedLocation = (loc) =>
    loc
      ? getLocationFromProvider(loc, { short: false, abbvState: true })
      : "";

  useEffect(() => {
    if (isUpdateMode && isDataLoaded && providerData) {
      // Map locations by location_type (API order can be secondary, additional, primary)
      const locations = normalizeProviderLocations(
        providerData?.provider_locations,
      );
      const primaryLocation =
        locations.find((loc) => loc?.location_type === "primary") ||
        locations[0];
      const additionalLocations = getNonPrimaryProviderLocations(locations);

      if (primaryLocation) {
        const street = primaryLocation.address1 || providerData?.address1 || "";
        const city = primaryLocation.city || providerData?.city || "";
        const state = primaryLocation.state || providerData?.state || "";
        const country = primaryLocation.country || providerData?.country || "";

        setValue("street_address", street);
        setValue("city", city);
        setValue("state", state);
        setValue("zip", primaryLocation.zip || "");
        // Keep country value as the country code for selects; display uses getFullLocationFormat
        setValue("country", country);

        // Populate the visible primaryLocation string in the desired format
        try {
          const formatted = getFormattedLocation(
            primaryLocation || { address1: street, city, state, country },
          );
          setValue("primaryLocation", formatted || "");
        } catch (e) {
          setValue(
            "primaryLocation",
            getFormattedLocation({ address: street, city, state, country }),
          );
        }

        // Ensure LocationFields controlled state is populated so selects show correct values
        setPrimaryAddress(street);
        setPrimaryCity(city);
        setPrimaryState(state);
        setPrimaryCountry(country);

        // Also set form-controlled primary fields for LocationFields component
        setValue("primaryAddress", street);
        setValue("primaryCity", city);
        setValue("primaryState", state);
        setValue("primaryCountry", country);
        setValue("street_address", street);

        setValue("city", city);
        setValue("state", state);
        setValue("country", country);
      }

      // Format the data according to the exact structure from the API response
      const formattedData = {
        name: providerData?.name || "",
        orgAbb: providerData?.name_abbreviation || "",
        url: providerData?.url || "",
        // Extract social media URLs from provider_social_links array
        // The API returns sociallinks with sociallinks_id, provider_id, platform, url
        linkedin_url:
          providerData?.provider_social_links?.find(
            (link) => link.platform === "LinkedIn",
          )?.url || "",
        facebook_url:
          providerData?.provider_social_links?.find(
            (link) => link.platform === "Facebook",
          )?.url || "",
        twitter_url:
          providerData?.provider_social_links?.find(
            (link) => link.platform === "Twitter",
          )?.url || "",
        instagram_url:
          providerData?.provider_social_links?.find(
            (link) => link.platform === "Instagram",
          )?.url || "",
        youtube_url:
          providerData?.provider_social_links?.find(
            (link) => link.platform === "YouTube",
          )?.url || "",
        description: providerData?.description || "",
        // Primary location: street, city, state, zip, country from primary location
        street_address:
          primaryLocation?.address1 ?? providerData?.address1 ?? "",
        city: primaryLocation?.city ?? providerData?.city ?? "",
        state: primaryLocation?.state ?? providerData?.state ?? "",
        zip: primaryLocation?.zip ?? providerData?.zip ?? "",
        country: primaryLocation?.country ?? providerData?.country ?? "",
        // Secondary/additional: only the location/address text (no city/state/country)
        secondary_address: getFormattedLocation(additionalLocations?.[0]) ?? "",
        additional_locations:
          getFormattedLocation(additionalLocations?.[1]) ??
          providerData?.other_address ??
          "",
        other_address: providerData?.other_address || "",
        landline_num: providerData?.landline_num || "",
        phone_number: providerData?.phone_number || "",
        email: providerData?.email || "",
        provider_type: providerData?.provider_service_type_id || "",
        company_type: providerData?.company_type || "",
        year_founded: providerData?.year_founded || "",
        annual_revenue_usd: providerData?.annual_revenue_range || "",
        locations_quality_management_system:
          providerData?.locations_quality_management_system || "",
        employee_range_id: providerData?.employee_range_id || "",
        rfi_count: providerData?.rfi_count || "",
        assessment_count: providerData?.assessment_count || "",
        number_of_sponsors_served:
          providerData?.number_of_sponsors_served || "",
        number_of_subsidiaries: providerData?.number_of_subsidiaries || 0,
        invited_by: providerData?.invited_by || "",
        is_legacy_account: providerData?.is_legacy_account || false,
        ticker: providerData?.ticker || "",
        pharma_sponsors_served: providerData?.pharma_sponsors_served || "",
        status: providerData?.status || "",
        comments: providerData?.comments || "",
        provider_file_name: providerData?.provider_file_name || "",

        // Boolean fields
        are_additional_locations_available:
          providerData?.are_additional_locations_available?.toString() ||
          "false",
        are_service_categories_same_across_locations:
          providerData?.are_capabilities_same_across_locations?.toString() ||
          providerData?.are_service_categories_same_across_locations?.toString() ||
          "false",
        pa_signed: providerData?.pa_signed?.toString() || "false",
        is_platform_ready:
          providerData?.active_on_platform?.toString() || "false",

        // Date fields
        first_invite_sent: providerData?.first_invite_sent
          ? {
            startDate: new Date(providerData?.first_invite_sent),
            endDate: new Date(providerData?.first_invite_sent),
          }
          : null,
        last_invite_sent: providerData?.last_invite_sent
          ? {
            startDate: new Date(providerData?.last_invite_sent),
            endDate: new Date(providerData?.last_invite_sent),
          }
          : null,
        pa_signed_date: providerData?.pa_signed_date
          ? {
            startDate: new Date(providerData?.pa_signed_date),
            endDate: new Date(providerData?.pa_signed_date),
          }
          : null,
        pa_expiration_date: providerData?.pa_expiration_date
          ? {
            startDate: new Date(providerData?.pa_expiration_date),
            endDate: new Date(providerData?.pa_expiration_date),
          }
          : null,

        // Multi-select fields — include Library Documents services so they stay in the input
        provider_capabilities: formatProviderCapabilitiesForForm(
          providerData,
          mergeLibrarySelected,
          rfis
        ),

        provider_therapeutic_areas:
          providerData?.provider_therapeutic_areas?.map((area) => ({
            value: area.therapeutic_area_id,
            label: area.therapeutic_area,
          })) || [],

        provider_indications:
          providerData?.provider_indications?.map((ind) => ({
            value: ind.indication_id,
            label: ind.indication,
          })) || [],

        provider_diversity_classifications:
          providerData?.provider_diversity_classifications?.map((div) => ({
            value: div.diversity_classification_id,
            label: div.diversity_classification,
          })) || [],

        provider_geographic_regions:
          providerData?.provider_geographic_regions?.map((region) => ({
            value: region.geographic_region_id,
            label: region.geographic_region,
          })) || [],

        provider_service_compliance_types:
          providerData?.provider_service_compliance_types?.map((comp) => ({
            value: comp.service_compliance_id,
            label: comp.service_compliance_name,
          })) || [],

        provider_languages:
          providerData?.provider_languages?.map((lang) => ({
            value: lang.language_id,
            label: lang.languages,
          })) || [],

        provider_affiliated_organizations:
          providerData?.provider_affiliated_organizations?.map((org) => ({
            value: org.affiliated_organization_id,
            label: org.affiliated_organization,
          })) || [],

        provider_other_capabilities:
          providerData?.provider_other_capabilities?.map((cap) => ({
            value: cap.other_capability_id,
            label: cap.other_capability_name,
          })) || [],

        provider_certifications:
          providerData?.provider_certifications?.map((cert) => ({
            value: cert.certification_id,
            label: cert.certification_name,
          })) || [],

        provider_other_certifications:
          providerData?.provider_other_certifications?.map((cert) => ({
            value: cert.other_certification_id,
            label: cert.other_certification_name,
          })) || [],
      };

      // Set the form values (additionalLocationsList is separate state — preserve after reset)
      const loadedAdditionalLocations = getNonPrimaryProviderLocations(
        locations,
      ).map(mapProviderLocationToAdditional);
      reset(formattedData);
      setAdditionalLocationsList(loadedAdditionalLocations);
      setLastSavedValues(formattedData);

      // Handle locations data (primaryLocation, secondaryLocations, additionalLocations already resolved above by location_type)
      if (providerData?.provider_locations?.length > 0) {
        if (primaryLocation) {
          setValue("street_address", primaryLocation.address1 || "");
          setValue("city", primaryLocation.city);
          setValue(
            "state",
            getStateOptions(primaryLocation.country).find(
              (option) => option.value === primaryLocation.state,
            )?.label || "",
          );
          setValue("zip", primaryLocation.zip || "");
          setValue("country", getCountryByValue(primaryLocation.country) || "");
          setValue(
            "primaryLocation",
            getFormattedLocation(primaryLocation),
          );
        }

        // Handle secondary location – only the location/address text (no city/state/country)
        if (additionalLocations?.length > 0) {
          setValue(
            "secondary_address",
            getFormattedLocation(additionalLocations[0]) ?? "",
          );
        }

        // Handle secondary location from provider_locations for service categories
        if (additionalLocations.length > 0) {
          // Set service categories for secondary location
          if (additionalLocations[0]?.rfi_template_id?.length > 0 && rfis) {
            const secondaryCategoryOptions = formatLocationCategoriesForForm(
              additionalLocations[0].rfi_template_id,
              rfis,
              providerData
            );

            setValue(
              "service_categories_secondary_location",
              secondaryCategoryOptions,
            );
          }
        }

        // Handle additional locations – only the location/address text (no city/state/country)
        if (additionalLocations.length > 1) {
          setValue(
            "additional_locations",
            getFormattedLocation(additionalLocations[1]) ?? "",
          );

          // Set number of additional locations
          setValue(
            "number_of_additional_locations",
            additionalLocations.length,
          );

          // Set service categories for additional locations
          if (additionalLocations[1]?.rfi_template_id?.length > 0 && rfis) {
            const additionalCategoryOptions = formatLocationCategoriesForForm(
              additionalLocations[1].rfi_template_id,
              rfis,
              providerData
            );

            setValue(
              "service_categories_additional_locations",
              additionalCategoryOptions,
            );
          }
        }
      }

      // Populate the selected therapeutic areas and indications
      if (providerData.provider_therapeutic_areas?.length) {
        const taIndications = {};

        providerData.provider_therapeutic_areas.forEach((area) => {
          const ta = area.therapeutic_area;

          // Find all indications for this therapeutic area
          const relatedIndications = (providerData.provider_indications || [])
            .filter(
              (ind) => ind.therapeutic_area_id === area.therapeutic_area_id,
            )
            .map((ind) => ({
              indication: ind.indication,
              indication_id: ind.indication_id,
            }));

          if (relatedIndications.length > 0) {
            taIndications[ta] = {
              indications: relatedIndications,
              therapeuticAreaId: area.therapeutic_area_id,
              indicationIds: relatedIndications.reduce((acc, ind) => {
                acc[ind.indication] = ind.indication_id;
                return acc;
              }, {}),
            };
          } else {
            // If no related indications found, at least include the therapeutic area
            taIndications[ta] = {
              indications: [],
              therapeuticAreaId: area.therapeutic_area_id,
              indicationIds: {},
            };
          }
        });

        setSelectedTAIndications(taIndications);
      }
    }
  }, [isUpdateMode, isDataLoaded, providerData, reset, setValue, rfis]);

  const optionsForMultiSelect = rfis?.map((item) => ({
    value: item?.rfi_id,
    label: item?.rfi_name,
  }));
  const optionsForTherapeuticAreas = threupatic?.map((item) => ({
    value: item?.id,
    label: item?.therapeutic_area + " " + item?.indication,
  }));

  // Sponsor/Admin see only these profile fields. Primary location only; additional locations are vendor-only (rendered separately).
  const SPONSOR_ADMIN_FIELD_NAMES = [
    "name",           // Full Organization Name
    "phone_number",   // Office Number
    "email",          // Company Email
    "company_type",  // Company Type
    "url",            // Website
    "primaryLocation", // Primary Location only (additional locations section is vendor-only)
  ];

  // Define all form fields in a single array
  const dualRoleLeadFields =
    mode === "create" && isVendorView
      ? [
          {
            name: "sponsor_organization",
            label: "Existing Sponsor Account",
            type: "sponsor-select",
            placeholder: "Select existing sponsor (optional)",
            fullWidth: true,
            required: false,
          },
        ]
      : [];

  const allFields = [
    ...dualRoleLeadFields,
    {
      name: "name",
      label: "Full Organization Name",
      type: "text",
      placeholder: "Enter Vendor name",
      required: true,
      fullWidth: true,
      disabled: mode === "create" && !!selectedSponsorIdDual,
    },
    {
      name: "orgAbb",
      label: "Organization Name Abbreviation",
      type: "text",
      placeholder: "Enter Organization Name Abbreviation",
      required: false,
    },
    {
      name: "phone_number",
      label: "Office Number",
      type: "text",
      placeholder: "Enter office number",
      required: true,
      privateInfoLabel: true,
      disabled:
        (isUpdateMode && providerData?.phone_number?.length > 0),
    },
    {
      name: "email",
      label: "Company Email",
      type: "text",
      placeholder: "Enter email address",
      required: true,
      privateInfoLabel: true,
      disabled: isCompanyEmailDisabled({
        mode,
        selectedSponsorIdDual,
        providerEmail: providerData?.email,
      }),
    },
    {
      name: isSponsorView ? "company_type" : "provider_type",
      label: "Company Type",
      type: isSponsorView ? "text" : "select",
      placeholder: isSponsorView ? "Enter company type" : "Select company type",
      required: true,
      options: isSponsorView ? [] : vendorTypeOptions,
    },

    {
      name: "url",
      label: "Website",
      type: "text",
      placeholder: "example.com",
      required: true,
      // disabled: isUpdateMode,
    },
    {
      name: "linkedin_url",
      label: "LinkedIn",
      type: "text",
      placeholder: "linkedin.com/company/yourcompany",
      required: false,
      fullWidth: true,
      titleSection: "Socials",
      avoidBorder: true,
    },
    {
      name: "facebook_url",
      label: "Facebook",
      type: "text",
      placeholder: "facebook.com/yourcompany",
      required: false,
      fullWidth: true,
      avoidBorder: true,
    },
    {
      name: "twitter_url",
      label: "X (Twitter)",
      type: "text",
      placeholder: "twitter.com/yourcompany",
      required: false,
      fullWidth: true,
      avoidBorder: true,
    },
    {
      name: "instagram_url",
      label: "Instagram",
      type: "text",
      placeholder: "instagram.com/yourcompany",
      required: false,
      fullWidth: true,
      avoidBorder: true,
    },
    {
      name: "youtube_url",
      label: "YouTube",
      type: "text",
      placeholder: "youtube.com/channel/yourchannelid",
      required: false,
      fullWidth: true,
      avoidBorder: false,
    },
    {
      name: "year_founded",
      label: "Established Date",
      type: "number",
      placeholder: "Enter year (e.g. 2015)",
      required: false,
    },
    {
      name: "employee_range_id",
      label: "Employees",
      type: "select",
      placeholder: "Select employee range",
      required: false,
      options: optionsForCompanySize,
      resolvedLabel: providerData?.employee_range,
    },
    {
      name: "primaryLocation",
      label: "Primary Location",
      type: "locationFields",
      placeholder: "Enter street address",
      required: true,
      fullWidth: true,
    },
    {
      name: "description",
      label: "About Us",
      type: "textarea",
      placeholder: "Enter description",
      required: false,
      fullWidth: true,
    },
    {
      name: "provider_capabilities",
      label: "Service Categories",
      type: "multi",
      placeholder: "Select service categories",
      required: true,
      fullWidth: true,
      options: optionsForMultiSelect,
    },
    {
      name: "provider_therapeutic_areas",
      label: "Therapeutic Areas & Indications",
      type: "multi",
      placeholder: "Select therapeutic areas & indications",
      required: false,
      fullWidth: true,
      options: optionsForTherapeuticAreas,
    },
    {
      name: "provider_other_capabilities",
      label: "Other Capabilities",
      type: "creatable-multi",
      placeholder: "Enter other capabilities",
      required: false,
      fullWidth: true,
    },
    {
      name: "provider_diversity_classifications",
      label: "Diversity Classifications",
      type: "multi",
      placeholder: "Select diversity classification",
      required: false,
      fullWidth: true,
      options: diversityClassificationData,
    },
    {
      name: "provider_affiliated_organizations",
      label: "Affiliated Organizations",
      type: "creatable-multi",
      placeholder: "Enter affiliated organizations",
      required: false,
    },
    {
      name: "annual_revenue_usd",
      label: "Recent Annual Revenue",
      type: "select",
      placeholder: "Select recent annual revenue",
      required: false,
      options: [
        {
          value: "under-500k",
          label: "Under $500,000",
        },
        {
          value: "500k-1m",
          label: "$500,000 - $1 mil.",
        },
        {
          value: "1m-5m",
          label: "$1 mil. - $5 mil.",
        },
        {
          value: "5m-10m",
          label: "$5 mil. - $10 mil.",
        },
        {
          value: "10m-25m",
          label: "$10 mil. - $25 mil.",
        },
        {
          value: "25m-50m",
          label: "$25 mil. - $50 mil.",
        },
        {
          value: "50m-100m",
          label: "$50 mil. - $100 mil.",
        },
        {
          value: "100m-250m",
          label: "$100 mil. - $250 mil.",
        },
        {
          value: "500m-1b",
          label: "$500 mil. - $1 bil.",
        },
        {
          value: "1b-5b",
          label: "$1 bil. - $5 bil.",
        },
        {
          value: "over-5b",
          label: "Over $5 bil.",
        },
      ], // Populate as needed
    },
    {
      name: "provider_languages",
      label: "Languages",
      type: "creatable-multi",
      placeholder: "Enter languages",
      required: false,
      fullWidth: true,
    },
  ];

  const visibleFields = isVendorView
    ? allFields
    : allFields.filter((field) => SPONSOR_ADMIN_FIELD_NAMES.includes(field.name));

  // Create state for multi-select fields
  const [therapeuticAreas, setTherapeuticAreas] = useState([]);
  const [indications, setIndications] = useState([]);
  const [capabilities, setCapabilities] = useState([]);
  const [otherCapabilities, setOtherCapabilities] = useState([]);

  // Function to dynamically determine if a field should be required based on form values
  const isFieldRequired = (fieldName, formValues) => {
    if (
      fieldName === "are_additional_locations_available" ||
      fieldName === "are_service_categories_same_across_locations"
    ) {
      // Make these fields required when additional locations are provided
      const numLocations = formValues?.number_of_additional_locations;
      const additionalLocations = formValues?.additional_locations;

      // Check both conditions - either number of locations or text in additional_locations
      const numValue = parseInt(numLocations, 10);
      const hasNumLocations = !isNaN(numValue) && numValue > 0;
      const hasAdditionalLocations =
        additionalLocations &&
        additionalLocations.trim &&
        additionalLocations.trim() !== "";

      return hasNumLocations || hasAdditionalLocations;
    } else if (fieldName === "service_categories_secondary_location") {
      // Make this field required when secondary_address is provided
      const secondaryAddress = formValues?.secondary_address;
      return (
        secondaryAddress &&
        secondaryAddress.trim &&
        secondaryAddress.trim() !== ""
      );
    } else if (fieldName === "service_categories_additional_locations") {
      // Make this field required when additional_locations is provided
      const additionalLocations = formValues?.additional_locations;
      return (
        additionalLocations &&
        additionalLocations.trim &&
        additionalLocations.trim() !== ""
      );
    }
    // Return the static required property for other fields
    const field = visibleFields.find((f) => f.name === fieldName);
    return field?.required || false;
  };

  // States for nested TA-Indication dropdown
  const [isTADropdownOpen, setIsTADropdownOpen] = useState(false);
  const [expandedTAs, setExpandedTAs] = useState([]);
  const [selectedTAIndications, setSelectedTAIndications] = useState({});
  const taDropdownRef = useRef(null);
  // Handler for multi-select changes

  const handleMultiSelectChange = (name, selectedOptions) => {
    switch (name) {
      case "therapeutic_areas":
        setTherapeuticAreas(selectedOptions);
        break;
      case "indications":
        setIndications(selectedOptions);
        break;
      case "capabilities":
        setCapabilities(selectedOptions);
        break;
      case "other_capabilities":
        setOtherCapabilities(selectedOptions);
        break;
      default:
        break;
    }
  };

  // State for disabling Next button
  const [isNextDisabled, setIsNextDisabled] = useState(false);
  // Function to validate only the current visible fields

  const {
    data: certificationsData,
    isLoading: isCertificationsLoading,
    isError: isCertificationsError,
  } = useProviderCertifications();

  const {
    data: geographicRegionData,
    isLoading: isGeographicRegionLoading,
    isError: isGeographicRegionError,
  } = useProviderGeographicRegion();

  const {
    data: affiliatedOrganizationData,
    isLoading: isAffiliatedOrganizationLoading,
    isError: isAffiliatedOrganizationError,
  } = useProviderAffiliatedOrganization();

  const {
    data: languagesData,
    isLoading: isLanguagesLoading,
    isError: isLanguagesError,
  } = useProviderLanguages();

  const mapToOptions = (array, valueKey, labelKey) => {
    if (!Array.isArray(array)) return [];

    return array.map((item) => ({
      value: item?.[valueKey],
      label: item?.[labelKey],
    }));
  };

  // Prepare the therapeutic area data for the nested dropdown
  const formatTherapeuticData = useMemo(() => {
    if (!therapeutics || !threupatic) return [];

    // Group indications by therapeutic area
    const taMap = {};

    // First, extract all unique therapeutic areas with their IDs
    therapeutics?.forEach((item) => {
      if (!taMap[item.therapeutic_area]) {
        taMap[item.therapeutic_area] = {
          therapeuticArea: item.therapeutic_area,
          therapeuticAreaId:
            item.therapeutic_area_id || "86414871-44bb-41e2-833c-140b241577e0",
          indications: [],
          indicationIds: {},
        };
      }
    });

    // Ensure all therapeutic areas are covered even if missing from therapeutics array
    threupatic?.forEach((item) => {
      const ta = item.therapeutic_area;
      if (!taMap[ta] && ta) {
        taMap[ta] = {
          therapeuticArea: ta,
          therapeuticAreaId: "86414871-44bb-41e2-833c-140b241577e0", // Default ID
          indications: [],
          indicationIds: {},
        };
      }
    });

    // Then, add indications to their respective therapeutic areas
    threupatic?.forEach((item) => {
      const ta = item.therapeutic_area;
      if (ta && item.indication) {
        // Add indication to the therapeutic area
        if (!taMap[ta].indications.includes(item.indication)) {
          taMap[ta].indications.push(item.indication);
        }
        // Store the indication ID mapped to the indication name
        taMap[ta].indicationIds[item.indication] = item.id;
      }
    });

    return Object.values(taMap);
  }, [therapeutics, threupatic]);


  // Auto-split street field and populate city/country
  const streetValue = watch("street_address");
  useEffect(() => {
    // Only run if streetValue contains at least two commas
    if (
      typeof streetValue === "string" &&
      (streetValue.match(/,/g) || []).length >= 2
    ) {
      // Debounce to avoid running on every keystroke
      const timeoutId = setTimeout(() => {
        const parts = streetValue
          .split(",")
          .map((p) => p.trim())
          .filter(Boolean);
        if (parts.length === 3) {
          setValue("street_address", parts[0], { shouldValidate: true });
          setValue("city", parts[1], { shouldValidate: true });
          setValue("country", parts[2], { shouldValidate: true });
        } else if (parts.length === 4) {
          setValue("street_address", parts[0], { shouldValidate: true });
          setValue("city", `${parts[1]}/${parts[2]}`, { shouldValidate: true });
          setValue("country", parts[3], { shouldValidate: true });
        }
      }, 1000); // 500ms debounce for user to finish typing
      return () => clearTimeout(timeoutId);
    }
  }, [streetValue, setValue]);

  // Force a revalidation when specific field values change
  useEffect(() => {
    const formValues = watch();
    // Get fields for current step only once
    const requiredFields = visibleFields.filter((field) => {
      // Check if field is dynamically required based on conditionallyRequired property
      if (field.conditionallyRequired) {
        return isFieldRequired(field.name, formValues);
      }
      return field.required;
    });

    if (requiredFields.length > 0) {
      // Check if any required fields are empty
      let hasInvalidField = false;
      for (const field of requiredFields) {
        const fieldValue = formValues[field.name];
        if (
          !fieldValue ||
          (Array.isArray(fieldValue) && fieldValue.length === 0) ||
          fieldValue === ""
        ) {
          hasInvalidField = true;
          break;
        }
      }

      setIsNextDisabled(hasInvalidField);
    }
  }, [
    watch,
    visibleFields,
    isFieldRequired,
    // Add specific fields that trigger conditional validation
    watch("additional_locations"),
    watch("secondary_address"),
    watch("number_of_additional_locations"),
    watch("are_additional_locations_available"),
    watch("service_categories_secondary_location"),
    watch("service_categories_additional_locations"),
  ]);

  // Close TA dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        taDropdownRef.current &&
        !taDropdownRef.current.contains(event.target)
      ) {
        setIsTADropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [taDropdownRef]);


  // Handlers for nested TA-Indication dropdown
  const toggleTAExpansion = (therapeuticArea) => {
    setExpandedTAs((prev) =>
      prev.includes(therapeuticArea)
        ? prev.filter((ta) => ta !== therapeuticArea)
        : [...prev, therapeuticArea],
    );
  };

  const handleTASelection = (
    therapeuticArea,
    indications,
    therapeuticAreaId,
    e,
  ) => {
    e.preventDefault();
    e.stopPropagation();

    // Find the therapeutic area data
    const taData = formatTherapeuticData.find(
      (t) => t.therapeuticArea === therapeuticArea,
    );
    if (!taData) return;

    setSelectedTAIndications((prev) => {
      const newState = { ...prev };

      // Check if therapeutic area is already selected
      const isCurrentlySelected = newState[therapeuticArea];

      if (isCurrentlySelected) {
        // If already selected, deselect the TA
        delete newState[therapeuticArea];
      } else {
        // Otherwise, select the TA (even if it has no indications)
        // Create objects for all indications with their IDs
        const formattedIndications = indications.map((indication) => ({
          indication: indication,
          indication_id: taData.indicationIds[indication],
        }));

        newState[therapeuticArea] = {
          indications: formattedIndications,
          therapeuticAreaId: therapeuticAreaId || taData.therapeuticAreaId,
          indicationIds: { ...taData.indicationIds },
        };
      }

      // Update the form values for validation
      const formattedTAs = Object.entries(newState).map(([ta, data]) => ({
        value: data.therapeuticAreaId,
        label: ta,
      }));

      const formattedIndications = [];
      Object.entries(newState).forEach(([ta, data]) => {
        data.indications.forEach((ind) => {
          const indicationId =
            typeof ind === "object"
              ? ind.indication_id
              : data.indicationIds[ind];

          if (indicationId) {
            formattedIndications.push({
              value: indicationId,
              label: typeof ind === "object" ? ind.indication : ind,
            });
          }
        });
      });

      setValue("provider_therapeutic_areas", formattedTAs);
      setValue("provider_indications", formattedIndications);

      return newState;
    });
  };

  const handleIndicationSelection = (
    therapeuticArea,
    indication,
    therapeuticAreaId,
    e,
  ) => {
    e.preventDefault();
    e.stopPropagation();

    // Find the therapeutic area data
    const taData = formatTherapeuticData.find(
      (t) => t.therapeuticArea === therapeuticArea,
    );
    if (!taData) return;

    setSelectedTAIndications((prev) => {
      const newState = { ...prev };

      if (!newState[therapeuticArea]) {
        // First indication for this TA
        newState[therapeuticArea] = {
          indications: [indication],
          therapeuticAreaId: therapeuticAreaId || taData.therapeuticAreaId,
          indicationIds: { ...taData.indicationIds },
        };
      } else if (
        newState[therapeuticArea].indications.some(
          (ind) => ind.indication === indication.indication,
        )
      ) {
        // Remove this indication
        newState[therapeuticArea] = {
          ...newState[therapeuticArea],
          indications: newState[therapeuticArea].indications.filter(
            (ind) => ind.indication !== indication.indication,
          ),
        };

        // If no indications are left, remove the therapeutic area
        if (newState[therapeuticArea].indications.length === 0) {
          delete newState[therapeuticArea];
        }
      } else {
        // Add this indication
        newState[therapeuticArea] = {
          ...newState[therapeuticArea],
          indications: [...newState[therapeuticArea].indications, indication],
        };
      }

      // Update the form values for validation
      const formattedTAs = Object.entries(newState).map(([ta, data]) => ({
        value: data.therapeuticAreaId,
        label: ta,
      }));

      const formattedIndications = [];
      Object.entries(newState).forEach(([ta, data]) => {
        data.indications.forEach((ind) => {
          const indicationId =
            typeof ind === "object"
              ? ind.indication_id
              : data.indicationIds[ind];

          if (indicationId) {
            formattedIndications.push({
              value: indicationId,
              label: typeof ind === "object" ? ind.indication : ind,
            });
          }
        });
      });

      setValue("provider_therapeutic_areas", formattedTAs);
      setValue("provider_indications", formattedIndications);

      return newState;
    });
  };

  const getVendorData = (data = {}) => {
    // Convert string boolean values to actual booleans before submission
    if (data.are_service_categories_same_across_locations === "true") {
      data.are_service_categories_same_across_locations = true;
    } else if (data.are_service_categories_same_across_locations === "false") {
      data.are_service_categories_same_across_locations = false;
    }

    if (data.are_additional_locations_available === "true") {
      data.are_additional_locations_available = true;
    } else if (data.are_additional_locations_available === "false") {
      data.are_additional_locations_available = false;
    }

    if (data.pa_signed === "true") {
      data.pa_signed = true;
    } else if (data.pa_signed === "false") {
      data.pa_signed = false;
    }

    if (data.is_platform_ready === "true") {
      data.is_platform_ready = true;
    } else if (data.is_platform_ready === "false") {
      data.is_platform_ready = false;
    }

    const guid = uuidv4();
    const providerId = isUpdateMode ? vendorId : guid;

    const vendorData = {
      provider_id: providerId,
      name: data.name,
      name_abbreviation: data.orgAbb,
      url: data.url,
      description: data.description,
      provider_service_type_id: data.provider_type,
      company_type: data.company_type,
      year_founded: data.year_founded || 0,
      annual_revenue_usd: 0,
      annual_revenue_range: data?.annual_revenue_usd,
      number_of_sponsors_served: data.number_of_sponsors_served || 0,
      number_of_subsidiaries: data.number_of_subsidiaries || 0,
      is_audit_report_available: data.is_audit_report_available,
      is_rfi_available: data.is_rfi_available,
      pa_signed: data.pa_signed,

      pa_signed_date: data?.pa_signed_date?.startDate ?? null,
      pa_expiration_date: data?.pa_expiration_date?.startDate ?? null,
      first_invite_sent: data?.first_invite_sent?.startDate ?? null,
      last_invite_sent: data?.last_invite_sent?.startDate ?? null,

      address1: primaryAddress,
      address2: null,
      other_address: data.secondary_address,
      city: primaryCity,
      state: primaryState,
      zip: data.zip,
      country: primaryCountry,

      phone_number: data.phone_number,
      landline_num: data.landline_num,
      ...mapCompanyEmailToProviderPayload(data.email),

      employee_range_id: data.employee_range_id || null,
      // provider_service_type_id: null,

      locations_quality_management_system:
        data.locations_quality_management_system,
      hc_org_id: isUpdateMode ? providerData?.hc_org_id : null,
      invited_by: data.invited_by,
      invite_status: data.invite_status,

      ticker: data.ticker,
      pharma_sponsors_served: data.pharma_sponsors_served,
      status: data.status,
      comments: data.comments,
      ext: data.ext,
      domain: data.domain,
      provider_file_name: data.provider_file_name,

      are_additional_locations_available:
        data.are_additional_locations_available,
      additional_locations_count: data.additional_locations_count,
      are_capabilities_same_across_locations:
        data.are_service_categories_same_across_locations,

      rfi_count: data.rfi_count || 0,
      assessment_count: data.assessment_count || 0,

      // Multi-select fields — keep Library Documents services even if the user tried to drop them
      provider_capabilities: formatProviderCapabilitiesForPayload(
        data.provider_capabilities,
        mergeLibrarySelected
      ),
      service_categories_additional_locations:
        data.service_categories_additional_locations?.map((cap) => ({
          rfi_id: cap.value,
          rfi_name: cap.label,
        })),
      service_categories_secondary_location:
        data.service_categories_secondary_location?.map((cap) => ({
          rfi_id: cap.value,
          rfi_name: cap.label,
        })),

      provider_therapeutic_areas: (data.provider_therapeutic_areas || []).map(
        (area) => ({
          therapeutic_area_id:
            area.value || "86414871-44BB-41E2-833C-140B241577E0",
          provider_id: providerId,
        }),
      ),

      provider_indications: (data?.provider_indications || []).map((ind) => ({
        indication_id: ind.value,
        provider_id: providerId,
      })),

      provider_other_capabilities: (
        data?.provider_other_capabilities || []
      ).map((cap) => {
        const other_cap_guid = uuidv4();
        return {
          other_capability_id: other_cap_guid,
          provider_id: providerId,
          other_capability_name: cap.label,
        };
      }),

      provider_certifications: (data?.provider_certifications || []).map(
        (cert) => ({
          certification_id: cert.value,
          provider_id: providerId,
        }),
      ),

      provider_other_certifications: (
        data?.provider_other_certifications || []
      ).map((cap) => {
        const other_cert_guid = uuidv4();
        return {
          other_certification_id: other_cert_guid,
          provider_id: providerId,
          other_certification_name: cap.label,
        };
      }),

      provider_diversity_classifications: (
        data?.provider_diversity_classifications || []
      ).map((div) => ({
        diversity_classification_id: div.value,
        provider_id: providerId,
      })),

      provider_geographic_regions: (
        data?.provider_geographic_regions || []
      ).map((region) => {
        return {
          geographic_region_id: region?.value,
          provider_id: providerId,
        };
      }),

      provider_service_compliance_types: (
        data?.provider_service_compliance_types || []
      ).map((comp) => ({
        service_compliance_id: comp.value,
        provider_id: providerId,
      })),

      provider_languages: (data?.provider_languages || []).map((cap) => {
        const languageId = uuidv4();
        return {
          languages: cap?.label,
          language_id: languageId,
          provider_id: providerId,
        };
      }),

      provider_affiliated_organizations: (
        data?.provider_affiliated_organizations || []
      ).map((org) => {
        const affiliated_organization_id = uuidv4();

        return {
          affiliated_organization_id: affiliated_organization_id,
          affiliated_organization: org?.label,
          provider_id: providerId,
        };
      }),

      active_on_platform: true,

      logo:
        orgData?.logo && !String(orgData.logo).startsWith("blob:")
          ? orgData.logo
          : providerData?.logo ?? null,

      provider_locations: [
        // primary
        {
          provider_location_id: null,
          address1: primaryAddress,
          address2: null,
          city: primaryCity,
          state: primaryState,
          zip: data?.zip,
          country: primaryCountry,
          location_type: "primary",
          is_primary: true,
          rfi_template_ids: toLocationRfiTemplateIds(data.provider_capabilities),
        },
        // additional – only the location/address field; no city/state/country from primary
        ...normalizeProviderLocations(additionalLocationsList).map((loc) => ({
          provider_location_id: null,
          address1: loc?.address ?? "",
          address2: null,
          city: loc?.city ?? "",
          state: loc?.state ?? "",
          zip: loc?.zip ?? "",
          country: loc?.country ?? "",
          location_type: "additional",
          rfi_template_ids: toLocationRfiTemplateIds(data.service_categories_additional_locations),
        })),
      ],
      // Creation: provider_sociallinks. Update: provider_social_links (API expects this key when updating)
      ...(isUpdateMode
        ? {
          provider_social_links: [
            ...(data.linkedin_url
              ? [
                {
                  sociallinks_id:
                    providerData?.provider_sociallinks?.find(
                      (link) => link.platform === "LinkedIn",
                    )?.sociallinks_id || undefined,
                  platform: "LinkedIn",
                  url: data.linkedin_url,
                  provider_id: providerData?.provider_id,
                },
              ]
              : []),
            ...(data.facebook_url
              ? [
                {
                  sociallinks_id:
                    providerData?.provider_sociallinks?.find(
                      (link) => link.platform === "Facebook",
                    )?.sociallinks_id || undefined,
                  platform: "Facebook",
                  url: data.facebook_url,
                  provider_id: providerData?.provider_id,
                },
              ]
              : []),
            ...(data.twitter_url
              ? [
                {
                  sociallinks_id:
                    providerData?.provider_sociallinks?.find(
                      (link) => link.platform === "Twitter",
                    )?.sociallinks_id || undefined,
                  platform: "Twitter",
                  url: data.twitter_url,
                  provider_id: providerData?.provider_id,
                },
              ]
              : []),
            ...(data.instagram_url
              ? [
                {
                  sociallinks_id:
                    providerData?.provider_sociallinks?.find(
                      (link) => link.platform === "Instagram",
                    )?.sociallinks_id || undefined,
                  platform: "Instagram",
                  url: data.instagram_url,
                  provider_id: providerData?.provider_id,
                },
              ]
              : []),
            ...(data.youtube_url
              ? [
                {
                  sociallinks_id:
                    providerData?.provider_sociallinks?.find(
                      (link) => link.platform === "YouTube",
                    )?.sociallinks_id || undefined,
                  platform: "YouTube",
                  url: data.youtube_url,
                  provider_id: providerData?.provider_id,
                },
              ]
              : []),
          ],
        }
        : {
          provider_sociallinks: [
            ...(data.linkedin_url
              ? [
                {
                  platform: "LinkedIn",
                  url: data.linkedin_url,
                  // For new providers, sociallinks_id will be generated by the backend
                },
              ]
              : []),
            ...(data.facebook_url
              ? [
                {
                  platform: "Facebook",
                  url: data.facebook_url,
                  // For new providers, sociallinks_id will be generated by the backend
                },
              ]
              : []),
            ...(data.twitter_url
              ? [
                {
                  platform: "Twitter",
                  url: data.twitter_url,
                  // For new providers, sociallinks_id will be generated by the backend
                },
              ]
              : []),
            ...(data.instagram_url
              ? [
                {
                  platform: "Instagram",
                  url: data.instagram_url,
                  // For new providers, sociallinks_id will be generated by the backend
                },
              ]
              : []),
            ...(data.youtube_url
              ? [
                {
                  platform: "YouTube",
                  url: data.youtube_url,
                  // For new providers, sociallinks_id will be generated by the backend
                },
              ]
              : []),
          ],
        }),
    };
    return vendorData;
  }

  const getSponsorData = (data = {}) => {
    const sponsor = {
      sponsor_name: data.name,
      website: data.url,
      office_number: data.phone_number,
      company_email: data.email,
      company_type: data.company_type,
      address1: primaryAddress || data.street_address,
      country: primaryCountry || data.country,
      city: primaryCity || data.city,
      state: primaryState || data.state,
      zip_code: data.zip,
      is_active: true,
    };
    return sponsor;
  }

  // Form values tracked internally
  // Form submission handler
  const onSubmit = (data) => {
    setFormSubmitted(true); // Show errors on submission attempt
    setIsLoading(true);

    if (mode === "create") {
      const vendorData = getVendorData(data);
      const selectedSponsor = data?.sponsor_organization;
      const sponsorIdSel = selectedSponsor?.sponsor_id || selectedSponsor?.value;
      const sponsorName =
        selectedSponsor?.sponsor_name || selectedSponsor?.label;

      const finishDualRoleUserUpdates = async (
        usersFromApi,
        initialUsersToUpdate,
      ) => {
        let usersToUpdate = initialUsersToUpdate;

        if (usersToUpdate.length === 0 && usersFromApi.length > 0) {
          const defaultRole = "Vendor Admin";
          const usersFromApiWithRoles = usersFromApi.map((user) => {
            const userSubRole =
              user.sub_role ||
              (user.sponsor_sub_roles && user.sponsor_sub_roles.length > 0
                ? user.sponsor_sub_roles[0].subrole
                : null) ||
              defaultRole;
            return {
              userId: user.sponsor_user_id || user.sponser_clerk_id,
              role: userSubRole,
            };
          });
          setSelectedUsersWithRoles(usersFromApiWithRoles);
          usersToUpdate = usersFromApiWithRoles.filter(
            (u) => u.role !== null && u.role !== undefined && u.role !== "",
          );
          if (usersToUpdate.length === 0) {
            setIsLoading(false);
            setIsSuccess(true);
            setMessage("Vendor with dual role created successfully!");
            setAlertOpen(true);
            setTimeout(() => navigate("/Backend/Users/Vendors"), 2000);
            return;
          }
        }

        if (usersToUpdate.length === 0) {
          setIsLoading(false);
          setIsSuccess(true);
          setMessage("Vendor with dual role created successfully!");
          setAlertOpen(true);
          setTimeout(() => navigate("/Backend/Users/Vendors"), 2000);
          return;
        }

        const updatePromises = usersToUpdate.map(async (u) => {
          const userObj = usersFromApi.find(
            (user) =>
              String(user.sponsor_user_id) === String(u.userId) ||
              String(user.sponser_clerk_id) === String(u.userId),
          );
          if (!userObj) {
            return { status: "not_found", userId: u.userId };
          }
          const roleName = u.role;
          const clerkId =
            userObj.sponser_clerk_id || userObj.sponsor_user_id || u.userId;
          const first_name = userObj.first_name;
          const last_name = userObj.last_name;
          const email = userObj.email;
          const sponsor_id =
            selectedSponsor?.sponsor_id || selectedSponsor?.value;
          const sponsor_name =
            selectedSponsor?.sponsor_name || selectedSponsor?.label;
          const phone_number =
            userObj.phone_number || userObj.landline_number || "";
          const office_phone_number =
            userObj.office_phone_number || userObj.landline_number || "";
          const org_id =
            selectedSponsor?.hypercomply_org_id ||
            userObj.hc_org_id ||
            userObj.org_id;

          const provider_user_permissions = vendorRightsList.map(
            (permission) => ({
              permissionId: uuidv4(),
              permission: permission,
            }),
          );
          const provider_user_subroles = [
            { subroleId: uuidv4(), subrole: roleName },
          ];
          let hcRespondRole = "Admin";
          if (roleName === "RFI Manager - Approver") {
            hcRespondRole = "Approver";
          } else if (roleName === "RFI Manager - User") {
            hcRespondRole = "User";
          }
          let hcDuediligenceRole = "Admin";
          if (roleName.includes("RFI Manager")) {
            hcDuediligenceRole = "Editor";
          }
          const updatePayload = {
            provider_user_permissions,
            provider_user_subroles,
            first_name,
            last_name,
            email,
            hc_duediligence_role: hcDuediligenceRole,
            hc_respond_role: hcRespondRole,
            provider_id: sponsor_id,
            provider_name: sponsor_name,
            phone_number,
            office_phone_number,
            primary: true,
            org_id,
          };
          try {
            await updateProviderUserRolesAsync({
              id: clerkId,
              roleData: updatePayload,
            });
            return { status: "success", userId: u.userId };
          } catch (err) {
            return { status: "error", userId: u.userId, error: err };
          }
        });

        const results = await Promise.all(updatePromises);
        const failed = results.filter(
          (r) => r.status === "error" || r.status === "not_found",
        );
        const failedEmails = failed.map((r) => {
          const userObj = usersFromApi.find(
            (user) =>
              String(user.sponsor_user_id) === String(r.userId) ||
              String(user.sponser_clerk_id) === String(r.userId),
          );
          return userObj?.email || r.userId;
        });
        const failedReason = failed
          .map((r) => r.error?.response?.data?.message)
          .find(Boolean);
        setIsLoading(false);
        setIsSuccess(failed.length === 0);
        setMessage(
          failed.length > 0
            ? `Vendor created, but carry-over failed for ${failedEmails.join(
              ", ",
            )}${failedReason ? `: ${failedReason}` : ""}`
            : "Vendor with dual role created successfully!",
        );
        setAlertOpen(true);
        setTimeout(
          () => navigate("/Backend/Users/Vendors"),
          failed.length > 0 ? 6000 : 2000,
        );
      };

      if (sponsorIdSel) {
        // The contact carry-over list comes from this fetch; submitting before
        // it resolves silently skipped the carry-over.
        if (isLoadingProviderUsers) {
          setIsLoading(false);
          setIsSuccess(false);
          setMessage(
            "Sponsor contact details are still loading. Please wait a moment and save again.",
          );
          setAlertOpen(true);
          return;
        }
        const dualRolePayload = {
          ...vendorData,
          name: sponsorName,
          provider_id: sponsorIdSel,
          hc_org_id: selectedSponsor?.hypercomply_org_id,
        };
        createProviderDualRole(dualRolePayload, {
          onSuccess: async () => {
            const usersFromApi = providerAllData?.users || [];
            const usersToUpdate = (selectedUsersWithRoles || []).filter(
              (u) =>
                u.role !== null && u.role !== undefined && u.role !== "",
            );
            await finishDualRoleUserUpdates(usersFromApi, usersToUpdate);
          },
          onError: (error) => {
            setIsLoading(false);
            setIsSuccess(false);
            setMessage(
              error.response?.data?.message ||
                error.message ||
                "Error creating vendor with dual role",
            );
            setAlertOpen(true);
          },
        });
        return;
      }

      if (typeof onCreateSubmit === "function") {
        onCreateSubmit(vendorData, {
          setIsLoading,
          setIsSuccess,
          setMessage,
          setAlertOpen,
        });
        return;
      }

      createProvider(vendorData, {
        onSuccess: () => {
          setIsLoading(false);
          setIsSuccess(true);
          setMessage("Vendor created successfully!");
          setAlertOpen(true);
          setTimeout(() => navigate("/Backend/Users/Vendors"), 2000);
        },
        onError: (error) => {
          setIsLoading(false);
          setIsSuccess(false);
          setMessage(
            error.response?.data?.message ||
              error.message ||
              "Error creating vendor",
          );
          setAlertOpen(true);
        },
      });
      return;
    }

    const vendorData = getVendorData(data);
    if (isUpdateMode && vendorId) {
      // Update existing vendor
      updateVendor(
        { id: vendorId, providerData: vendorData },
        {
          onSuccess: async () => {
            const navigationOnRoles =
              currentUserType === "vendor" ? "/" : "/Backend/Users/Vendors";
            await finalizeProfileSave({
              address: vendorData.address1,
              city: vendorData.city,
              state: vendorData.state,
              country: vendorData.country,
              zip: vendorData.zip,
            });
            setIsLoading(false);
            setIsSuccess(true);
            setMessage("Vendor updated successfully!");
            setAlertOpen(true);
            setIsEditMode(false);
            // setTimeout(() => {
            //   navigate(navigationOnRoles);
            // }, 2000);
          },
          onError: (error) => {
            setIsLoading(false);
            setIsSuccess(false);
            setMessage(error.message || "Error updating vendor");
            setAlertOpen(true);
          },
        },
      );
    }
    else if (isUpdateMode && sponsorId) {
      // Update existing sponsor

      const sponsorData = getSponsorData(data);
      console.log("sponsorData", sponsorData);
      updateSponsor(
        { id: sponsorId, userData: sponsorData },
        {
          onSuccess: async () => {
            const navigationOnRoles =
              currentUserType === "sponsor" ? "/" : "/Backend/Users/Sponsors";
            await finalizeProfileSave({
              address: sponsorData.address1,
              city: sponsorData.city,
              state: sponsorData.state,
              country: sponsorData.country,
              zip: sponsorData.zip_code,
            });
            setIsLoading(false);
            setIsSuccess(true);
            setMessage("Sponsor updated successfully!");
            setAlertOpen(true);
            setIsEditMode(false);
            // setTimeout(() => {
            //   navigate(navigationOnRoles);
            // }, 2000);
          },
          onError: (error) => {
            setIsLoading(false);
            setIsSuccess(false);
            setMessage(error.message || "Error updating sponsor");
            setAlertOpen(true);
          },
        },
      );
    }
  };

  const getExportData = (activeTab) => {
    return activeTab === "overview"
      ? [] //getProfileData
      : activeTab === "documents"
        ? [] // getDocsData
        : []; // getTeamData

    // return activeTab === "overview"
    //   ? getProfileData
    //   : activeTab === "documents"
    //     ? getDocsData
    //     : getTeamData;
  };

  let socialGroupRendered = false;
  const socialNames = [
    "linkedin_url",
    "facebook_url",
    "twitter_url",
    "instagram_url",
    "youtube_url",
  ];
  const renderNotEditableFields = (field) => {
    if (field.name === "sponsor_organization") {
      const sel = watch("sponsor_organization");
      const display =
        sel?.sponsor_name || sel?.name || sel?.label || "None (new vendor)";
      return (
        <div
          key="sponsor-org-view"
          className={`${field.fullWidth ? "col-span-full" : ""} border-b border-gray-100 pb-6 col-span-full`}
        >
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {field.label}
          </label>
          <div className="mt-1 text-sm text-gray-900">{display}</div>
        </div>
      );
    }

    // If this field is a social field, render a single grouped row with border and spacing
    if (socialNames.includes(field.name)) {
      if (socialGroupRendered) return null; // already rendered group
      socialGroupRendered = true;
      return (
        <div
          key="social-icons-view"
          className="col-span-full border-b border-gray-100 pb-6"
        >
          <div className="mt-1 flex items-center gap-4">
            {socialNames.map((n) => (
              <div key={n} className="flex-shrink-0">
                <SocialIcon name={n} url={watch(n)} />
              </div>
            ))}
          </div>
        </div>
      );
    }

    // Special-case for locationFields to format primary location as "address, city, state, country"
    if (field.type === "locationFields" || field.name === "primaryLocation") {
      const locObj = {
        address1: primaryAddress || watch("street_address"),
        city: primaryCity || watch("city"),
        state: primaryState || watch("state"),
        country: primaryCountry || watch("country"),
      };
      const formatted = getFormattedLocation(locObj);

      return (
        <div
          key={`${field.name}-view`}
          className={`${field.fullWidth ? "col-span-full" : ""} border-b border-gray-100 pb-6`}
        >
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {field.label}{" "}
            {field.required && <span className="text-red-500">*</span>}
          </label>

          <div className="mt-1">
            <div>
              {formatted ? (
                <span>{formatted}</span>
              ) : (
                <span className="text-gray-400">-</span>
              )}
            </div>
          </div>

          {/* Additional locations list (non-editable) - vendor only */}
          {isVendorView && (
            <div className="mt-6 pt-6 border-t border-gray-100">
              {additionalLocationsList && additionalLocationsList.length > 0 ? (
                additionalLocationsList.map((loc, i) => (
                  <div
                    key={i}
                    className={`${i > 0 ? "pt-4 border-t border-gray-100 mt-4" : ""} mb-4`}
                  >
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {`Additional Location ${i + 1}`}
                    </label>
                    <div className="mt-1">
                      <div>
                        {getFormattedLocation(loc) ? (
                          <span>{getFormattedLocation(loc)}</span>
                        ) : (
                          <span className="text-gray-400">-</span>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Additional Locations
                  </label>
                  <div className="mt-1">
                    <div>
                      <span className="text-gray-400">-</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      );
    }

    // Service categories (provider_capabilities) - same badges as Library Documents cards
    if (field.name === "provider_capabilities") {
      const formCaps = watch("provider_capabilities") || [];
      const serviceCategories = resolveVendorProfileServiceCategories({
        profile: {
          provider_capabilities: formCaps,
          capabilities: getProviderCapabilitiesList(providerData),
        },
        documents: libraryDocuments,
        rfisList,
      });
      return (
        <div
          key={`${field.name}-view`}
          className={`${field.fullWidth ? "col-span-full" : ""} border-b border-gray-100 pb-6`}
        >
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {field.label}{" "}
            {field.required && <span className="text-red-500">*</span>}
          </label>
          <div className="mt-1">
            {serviceCategories.length > 0 ? (
              <Capabilities
                services={serviceCategories.map(({ capability }) => capability)}
                applyRfiCatalogCustomLabels={true}
              />
            ) : (
              <div className="text-sm text-gray-400">-</div>
            )}
          </div>
        </div>
      );
    }

    // Generic field rendering: label + boxed value to match prototype spacing and borders
    return (
      <div
        key={`${field.name}-view`}
        className={`${field.fullWidth ? "col-span-full" : ""} border-b border-gray-100 pb-6`}
      >
        <>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {field.label}{" "}
            {field.required && <span className="text-red-500">*</span>}
          </label>
          <div className="mt-1">
            <div>
              {(() => {
                const value = watch(field.name);
                if (
                  value == null ||
                  value === "" ||
                  (Array.isArray(value) && value.length === 0)
                )
                  return <span className="text-gray-400">-</span>;

                // Website field: show clickable link when available
                if (field.name === "url") {
                  const href =
                    typeof value === "string" && value.trim()
                      ? value.startsWith("http")
                        ? value
                        : `https://${value}`
                      : null;
                  return href ? (
                    <a
                      href={href}
                      target="_blank"
                      rel="noreferrer"
                      className="text-sm text-blue-600 hover:text-blue-800"
                    >
                      {value}
                    </a>
                  ) : (
                    <span className="text-gray-400">-</span>
                  );
                }

                if (Array.isArray(value)) {
                  return (
                    <div className="flex flex-wrap">
                      {value
                        .map((v) =>
                          typeof v === "object"
                            ? v.label || v.value || v.rfi_name
                            : v,
                        )
                        .filter(Boolean)
                        .map((label, idx) => (
                          <span
                            key={`${String(label)}-${idx}`}
                            className="inline-flex items-center bg-white border border-gray-200 text-gray-800 text-xs font-medium rounded-md px-2 py-0.5 mr-2 mb-1"
                            style={{
                              boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.03)",
                            }}
                          >
                            {label}
                          </span>
                        ))}
                    </div>
                  );
                }
                if (typeof value === "object")
                  return value.label || value.value || JSON.stringify(value);
                // primitive
                return resolveReadOnlyOptionLabel({
                  options: field.options,
                  value,
                  resolvedLabel: field.resolvedLabel,
                });
              })()}
            </div>
          </div>
        </>
      </div>
    );
  };


  return (
    <div className="flex min-h-screen w-full flex-col bg-gray-50">
      <NotificationModal
        open={alertOpen}
        setOpen={setAlertOpen}
        desc={message}
        title={isSuccess ? "Success" : "Error"}
        error={!isSuccess}
      />

      <CustomConfirmModal
        open={isConfirmingVqaOnlyOff}
        setOpen={setIsConfirmingVqaOnlyOff}
        title="Turn off VQA only?"
        desc="Its users will be able to request VQQs. The organization gets a HyperComply organization, if it has none yet, and its users get HyperComply accounts. These stay even if VQA only is turned back on."
        onClick={() => {
          setIsConfirmingVqaOnlyOff(false);
          saveSettings();
        }}
      />

      <header className="bg-white shadow-header mb-6 mt-1">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="py-4">
            {/* Breadcrumbs - context-aware based on user type */}
            <div className="flex items-center text-sm font-medium leading-6 text-gray-500 mb-6">
              <span className="hover:text-gray-900 cursor-pointer" onClick={() => {
                if (currentUserType === "admin") {
                  navigate(isVendorView ? "/Backend/Users/Vendors" : "/Backend/Users/Sponsors");
                } else {
                  navigate("/");
                }
              }}>
                {currentUserType === "admin" ? isVendorView ? "Vendors" : "Sponsors" : "Dashboard"}
              </span>
              <svg
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
                className="h-5 w-5 flex-none text-gray-400 mx-2"
              >
                <path
                  fillRule="evenodd"
                  d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                  clipRule="evenodd"
                ></path>
              </svg>
              <span className="text-gray-900">
                {mode === "create"
                  ? "Create Vendor Account"
                  : isSponsorView
                    ? "Manage Sponsor Account"
                    : "Manage Vendor Account"}
              </span>
            </div>

            {/* Header */}
            <div className="flex items-center justify-between gap-x-8">
              <div className="flex items-center gap-x-6">
                <div className="group relative">
                  <input
                    ref={logoInputRef}
                    type="file"
                    accept=".png"
                    className="hidden"
                    disabled={isUploadingLogo}
                    onChange={handleLogoUpload}
                  />
                  <button
                    type="button"
                    disabled={isUploadingLogo}
                    onClick={() => !isUploadingLogo && logoInputRef.current?.click()}
                    className="rounded-md bg-gray-100 flex items-center justify-center h-32 w-48 cursor-pointer hover:ring-2 hover:ring-indigo-400 hover:ring-offset-1 transition-all relative overflow-hidden disabled:opacity-60 disabled:cursor-wait"
                    title="Click to upload a new logo"
                  >
                    {orgData?.logo ? (
                      <img
                        src={orgData.logo}
                        alt={`${orgData?.name || "Organization"} logo`}
                        className="h-28 w-40 object-contain"
                      />
                    ) : (
                      <span className="text-xs text-gray-500 px-3 text-center leading-snug">
                        Upload logo (PNG)
                      </span>
                    )}
                    {isUploadingLogo && (
                      <div className="absolute inset-0 bg-black/40 flex flex-col items-center justify-center text-white text-xs font-medium">
                        Uploading…
                      </div>
                    )}
                    <div
                      className={`absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center text-white rounded-md ${isUploadingLogo ? "pointer-events-none opacity-0" : ""}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-6 h-6 mb-1"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"
                        />
                      </svg>
                      <span className="text-xs font-medium">Upload Logo</span>
                      <span className="text-[10px] text-gray-300 mt-0.5">
                        .png only
                      </span>
                    </div>
                  </button>
                  <p className="mt-1 text-[10px] text-gray-400 text-center w-48">
                    PNG with transparent background recommended. Full-color or
                    all black.
                  </p>
                </div>
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <h2 className="text-xl font-bold leading-7 text-gray-900">
                      {orgData.name || (mode === "create" ? "New vendor" : "")}
                    </h2>
                    {mode !== "create" && (
                      <>
                        {shouldShowOrgStatusBadge(orgData?.is_active) && (
                          <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${orgData.is_active ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>
                            {getActiveStatusLabel(orgData.is_active)}
                          </span>
                        )}
                        {shouldShowDiscoveryStatusBadge(orgData?.discovery_status, isVendorView) && (
                          <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${orgData.discovery_status ? 'bg-blue-100 text-blue-700' : 'bg-yellow-100 text-yellow-700'}`}>
                            {getDiscoveryStatusLabel(orgData.discovery_status)}
                          </span>
                        )}
                      </>
                    )}
                  </div>
                  <p className="text-base leading-6 text-gray-600">
                    {mode === "create"
                      ? "Complete the vendor profile and upload a logo if needed."
                      : activeTab === "settings"
                        ? isVendorView
                          ? "Control security and access settings for this vendor organization."
                          : "Control security, features, and access settings for this sponsor organization."
                        : activeTab === "documents"
                        ? isVendorView
                          ? isAdmin
                            ? "Documents this vendor currently offers in the Library."
                            : "Documents your organization currently offers in the Library."
                          : isAdmin
                          ? "Every Library-traceable document this sponsor has acquired."
                          : "Documents your organization has acquired through the platform."
                        : activeTab === "overview"
                        ? currentUserType === "admin"
                          ? isVendorView
                            ? "View and edit the vendor organization profile."
                            : "View and edit the sponsor organization profile."
                          : "View and edit your organization profile."
                        : currentUserType === "admin"
                          ? isVendorView
                            ? "Manage the vendor organization team members and their roles."
                            : "Manage the sponsor organization team members and their roles."
                          : "Manage your team members and their roles."}
                  </p>
                </div>
              </div>
              {/*<div className="flex-shrink-0 self-start mt-2 flex items-center gap-3">
                <MultiTabExportMenu
                  tabs={
                    [
                      {
                        key: "profile",
                        label: "Company Profile",
                        // getData: getProfileData,
                        getData: [],
                      },
                      {
                        key: "documents",
                        label: "Library Documents",
                        // getData: getDocsData,
                        getData: [],
                        cellStyles: documentLibraryCellStyles,
                      },
                      {
                        key: "team",
                        label: "Team",
                        // getData: getTeamData,
                        getData: [],
                        cellStyles: usersCellStyles,
                      },
                    ]
                  }
                  pageTitle={`${orgData.name} - Vendor Account`}
                  filePrefix={`Vendor_${(orgData.name || "Account").replace(/\s+/g, "_")}`}
                />
              </div>*/}
            </div>
          </div>
        </div>

        {/* Stats Section */}
        {mode !== "create" && (
        <section className="border-b border-gray-100">
          <div className="px-4 sm:px-6 lg:px-8">
            {isVendorView
              ? <VendorExpandableStats
                stats={stats}
                detailsData={statsDetails}
              />
              : <UserDashboardStats stats={stats} />
            }
          </div>
        </section>
        )}
      </header>

      <div className="flex min-h-0 flex-1 flex-col px-4 pb-8 sm:px-6 lg:px-8">
        <div className="flex flex-1 flex-col space-y-4">
          {/* Navigation Tabs */}
          <nav>
            <div className="relative border-b border-gray-200 px-4 sm:px-6 lg:px-8">
              <ul className="flex flex-none gap-x-6 text-sm font-medium text-gray-500">
                {tabs.map((tab) => (
                  <li key={tab.key}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        if (activeTab === "settings" && isSettingsEditMode && currentOrg) {
                          setOrgData((prev) => ({
                            ...prev,
                            ...getOrgSubscriptionSettingsFromApi(currentOrg),
                          }));
                        }
                        setActiveTab(tab.key);
                        if (tab.key !== "overview") setIsEditMode(false);
                        if (tab.key !== "settings") {
                          setIsSettingsEditMode(false);
                          setSettingsSnapshot(null);
                        }
                      }}
                      className={`pb-4 inline-block border-b-2 ${activeTab === tab.key
                        ? "border-indigo-600 text-indigo-600"
                        : "border-transparent hover:text-gray-700 hover:border-gray-300"
                        }`}
                    >
                      {tab.name}
                    </a>
                  </li>
                ))}
              </ul>
              {/* Absolute so search/actions never change tab row height; bottom-4 matches tab pb-4 so icon/input align with tab labels */}
              <div className="absolute bottom-4 right-4 top-0 flex items-center gap-3 sm:right-6 lg:right-8">
                {activeTab === "users" && (
                  <div
                    className={`relative flex items-center transition-all duration-300 ease-in-out ${isTeamSearchExpanded ? "w-64" : "w-auto"}`}
                  >
                    {isTeamSearchExpanded ? (
                      <div className="relative w-full">
                        <MagnifyingGlassIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
                        <input
                          ref={teamSearchInputRef}
                          type="text"
                          placeholder="Search team members..."
                          value={teamSearchTerm}
                          onChange={(e) => {
                            const value = e.target.value;
                            setTeamSearchTerm(value);
                            debouncedSetTeamSearch(value);
                          }}
                          onBlur={() => !teamSearchTerm && setIsTeamSearchExpanded(false)}
                          className="block w-full rounded-md border-0 py-1.5 pl-9 pr-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    ) : (
                      <button
                        type="button"
                        onClick={() => setIsTeamSearchExpanded(true)}
                        className="p-2 text-gray-400 hover:text-indigo-600 transition-colors rounded-md hover:bg-gray-100"
                        aria-label="Search team members"
                      >
                        <MagnifyingGlassIcon className="h-5 w-5" />
                      </button>
                    )}
                  </div>
                )}
                {activeTab === "users" && (
                  <TableExportMenu
                    getData={getTeamUsersExportData}
                    reportTitle={`${isVendorView ? "Vendor" : "Sponsor"} Team Members`}
                    reportSubtitle="Current filtered team members view"
                    filePrefix={`${isVendorView ? "Vendor" : "Sponsor"}_Team_Members`}
                    downloadType="Team Members"
                  />
                )}
              </div>
            </div>
          </nav>

          {(() => {
            const settingsSaveLabel = isSettingsSaving ? "Saving…" : "Save";
            const settingsOptionClassName = `flex gap-3 ${isSettingsEditMode && !isSettingsSaving ? "cursor-pointer" : "cursor-default pointer-events-none"}`;
            if (activeTab === "overview") return (<div className="w-full bg-white shadow-sm rounded-lg">
            <div className="w-full px-6 pt-6 flex justify-end">
              {!isEditMode ? (
                <button
                  type="button"
                  onClick={() => {
                    syncPrimaryLocationDisplayFields();
                    setLastSavedValues(getValues());
                    setIsEditMode(true);
                    setFormSubmitted(false);
                  }}
                  className="inline-flex items-center rounded-md bg-indigo-600 hover:bg-indigo-500 text-white px-3 py-2 text-sm font-medium focus:outline-none"
                >
                  Edit profile
                </button>
              ) : (
                <div className="inline-flex items-center space-x-2">
                  <button
                    type="button"
                    onClick={handleCancelEdit}
                    className="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={handleSave}
                    className="inline-flex items-center rounded-md bg-indigo-600 hover:bg-indigo-500 text-white px-3 py-2 text-sm font-medium focus:outline-none"
                  >
                    {mode === "create" ? "Create vendor" : "Save"}
                  </button>
                </div>
              )}
            </div>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                setFormSubmitted(true);
                syncPrimaryLocationFormValues();
                handleSubmit(
                  (data) => {
                    if (!runAdditionalLocationValidation()) {
                      setIsLoading(false);
                      return;
                    }
                    onSubmit(data);
                  },
                  (errors) => {
                    runAdditionalLocationValidation();
                    setFormSubmitted(true);
                    setIsLoading(false);
                    console.error("Validation errors:", errors);
                  },
                )(e);
              }}
              className="w-full p-6"
            >

              {/* Form fields for current step */}
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
                {(() => {
                  return visibleFields.map((field) => (
                    <>
                      {field.titleSection && (
                        <span className="w-full text-sm font-medium text-gray-900 col-span-full">
                          {field.titleSection}
                        </span>
                      )}
                      {/* Read-only view when not editing: show labels instead of inputs */}
                      {!isEditMode && renderNotEditableFields(field)}
                      <div
                        key={field.name}
                        className={`${field.avoidBorder ? "" : "border-b border-gray-100 pb-6"} ${field.fullWidth ? "col-span-full" : ""}`}
                        style={{ display: isEditMode ? undefined : "none" }}
                      >
                        {field.type === "sponsor-select" ? (
                          <div className="flex flex-col col-span-full w-full">
                            <label className="block text-sm font-medium text-gray-700 mb-3">
                              {field.label}{" "}
                              {field.required && (
                                <span className="text-red-600">*</span>
                              )}
                            </label>
                            <div className="flex flex-col gap-6 w-full">
                              <div className="w-full flex flex-col">
                                {isLoadingSponsors ? (
                                  <div className="text-sm text-gray-500 py-2">
                                    Loading sponsors...
                                  </div>
                                ) : (
                                  <Controller
                                    name={field.name}
                                    control={control}
                                    render={({ field: sponsorField }) => {
                                      const selectedOpt = (() => {
                                        const v = sponsorField.value;
                                        if (
                                          v == null ||
                                          v?.isNoneOption
                                        ) {
                                          return sponsorSelectOptions[0];
                                        }
                                        return (
                                          sponsorSelectOptions.find(
                                            (o) =>
                                              o.data?.sponsor_id ===
                                                v?.sponsor_id ||
                                              o.value === v?.sponsor_id,
                                          ) || sponsorSelectOptions[0]
                                        );
                                      })();
                                      return (
                                        <Select
                                          inputId={`sponsor-select-${field.name}`}
                                          isDisabled={field.disabled}
                                          options={sponsorSelectOptions}
                                          styles={FORM_SINGLE_SELECT_STYLES}
                                          placeholder={
                                            field.placeholder ||
                                            "Select existing sponsor"
                                          }
                                          isSearchable
                                          filterOption={createFilter({
                                            ignoreAccents: true,
                                            trim: true,
                                          })}
                                          isClearable={false}
                                          getOptionValue={(o) =>
                                            String(o.value)
                                          }
                                          value={selectedOpt}
                                          onChange={(opt) => {
                                            if (
                                              !opt ||
                                              opt.value === "__none__" ||
                                              opt.data?.isNoneOption
                                            ) {
                                              sponsorField.onChange(null);
                                              clearSponsorFields();
                                            } else {
                                              sponsorField.onChange(opt.data);
                                            }
                                          }}
                                          noOptionsMessage={() =>
                                            "No sponsors found"
                                          }
                                          components={{
                                            IndicatorSeparator: () => null,
                                            ClearIndicator: () => null,
                                            DropdownIndicator: (
                                              indicatorProps,
                                            ) => (
                                              <components.DropdownIndicator
                                                {...indicatorProps}
                                              >
                                                <ChevronUpDownIcon
                                                  className="h-5 w-5 text-gray-400"
                                                  aria-hidden="true"
                                                />
                                              </components.DropdownIndicator>
                                            ),
                                          }}
                                        />
                                      );
                                    }}
                                  />
                                )}
                                {formSubmitted && errors[field.name] && (
                                  <p className="mt-1.5 text-sm text-red-600">
                                    {errors[field.name].message}
                                  </p>
                                )}
                              </div>
                              {selectedSponsorIdDual &&
                                selectedSponsorOrgIdDual && (
                                  <div className="flex-1 min-w-0">
                                    <OrganizationUsersGrid
                                      providerId={selectedSponsorIdDual}
                                      orgId={selectedSponsorOrgIdDual}
                                      providerData={providerDetailsWithUsers}
                                      isLoading={isLoadingProviderUsers}
                                      isError={isErrorProviderUsers}
                                      onRoleChange={handleUserRoleChange}
                                      roleType="vendor"
                                    />
                                  </div>
                                )}
                            </div>
                          </div>
                        ) : field.type === "multi" &&
                          field.name === "provider_therapeutic_areas" ? (
                          <div className="relative" ref={taDropdownRef}>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              {field.label}{" "}
                              {field.required && (
                                <span className="text-red-500">*</span>
                              )}
                            </label>
                            <div
                              className="relative w-full cursor-pointer rounded-md bg-white py-2 pl-3 pr-10 min-h-[40px] text-left outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600 sm:text-sm flex items-center"
                              onClick={() =>
                                setIsTADropdownOpen(!isTADropdownOpen)
                              }
                            >
                              <div className="flex flex-wrap items-center gap-1 min-h-0 w-full relative">
                                {/* Magnifying glass icon and placeholder, matching other filters */}
                                {Object.keys(selectedTAIndications).length ===
                                  0 && (
                                    <>
                                      <span className="absolute left-0 top-1/2 -translate-y-1/2 flex items-center">
                                        <MagnifyingGlassIcon className="h-4 w-4 text-gray-400" />
                                      </span>
                                      <span className="text-gray-400 pl-5">
                                        Therapeutic Areas & Indications
                                      </span>
                                    </>
                                  )}
                                {/* Badges for selected TAs/Indications */}
                                {(() => {
                                  const allTAOptions =
                                    formatTherapeuticData.map(
                                      (t) => t.therapeuticArea,
                                    );
                                  const selectedTAs = Object.keys(
                                    selectedTAIndications || {},
                                  );
                                  const allSelected =
                                    selectedTAs.length ===
                                    allTAOptions.length &&
                                    allTAOptions.length > 0;

                                  if (allSelected) {
                                    return (
                                      <span className="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium ring-1 bg-white text-gray-900 ring-gray-200 ring-inset">
                                        All Therapeutic Areas & Indications
                                        <button
                                          type="button"
                                          className="group relative -mr-1 h-3.5 w-3.5 rounded-sm hover:bg-gray-500/20"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedTAIndications({});
                                          }}
                                        >
                                          <span className="sr-only">
                                            Remove all therapeutic areas
                                          </span>
                                          <svg
                                            viewBox="0 0 14 14"
                                            className="h-3.5 w-3.5 stroke-current"
                                          >
                                            <path d="M4 4l6 6m0-6l-6 6" />
                                          </svg>
                                        </button>
                                      </span>
                                    );
                                  } else if (selectedTAs.length > 0) {
                                    return Object.entries(
                                      selectedTAIndications,
                                    ).map(([ta, data]) => {
                                      const allIndicationsForTA =
                                        formatTherapeuticData.find(
                                          (t) => t.therapeuticArea === ta,
                                        )?.indications || [];
                                      const label =
                                        data.indications.length ===
                                          allIndicationsForTA.length
                                          ? `${ta}: All`
                                          : `${ta}: ${data.indications
                                            .map((ind) =>
                                              typeof ind === "object"
                                                ? ind.indication
                                                : ind,
                                            )
                                            .join(", ")}`;
                                      return (
                                        <span
                                          key={ta}
                                          className="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium ring-1 bg-white text-gray-900 ring-gray-200 ring-inset"
                                        >
                                          {label}
                                          <button
                                            type="button"
                                            className="group relative -mr-1 h-3.5 w-3.5 rounded-sm hover:bg-gray-500/20"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setSelectedTAIndications(
                                                (prev) => {
                                                  const newState = { ...prev };
                                                  delete newState[ta];
                                                  return newState;
                                                },
                                              );
                                            }}
                                          >
                                            <span className="sr-only">
                                              Remove {ta}
                                            </span>
                                            <svg
                                              viewBox="0 0 14 14"
                                              className="h-3.5 w-3.5 stroke-current"
                                            >
                                              <path d="M4 4l6 6m0-6l-6 6" />
                                            </svg>
                                          </button>
                                        </span>
                                      );
                                    });
                                  }
                                  return null;
                                })()}
                              </div>
                              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                <ChevronUpDownIcon
                                  className="h-5 w-5 text-gray-400"
                                  aria-hidden="true"
                                />
                              </span>
                            </div>
                            {isTADropdownOpen && (
                              <div className="absolute z-20 mt-1 w-full overflow-auto rounded-md bg-white py-1 text-base ring-1 shadow-lg ring-black/5 focus:outline-none sm:text-sm max-h-96">
                                {/* Add All Option */}
                                <div className="relative">
                                  <div
                                    className={`relative cursor-pointer select-none py-2 pl-3 pr-9 ${Object.keys(selectedTAIndications)
                                      .length === formatTherapeuticData.length
                                      ? "bg-indigo-600 text-white"
                                      : "text-gray-900 hover:bg-indigo-600 hover:text-white"
                                      }`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setSelectedTAIndications((prev) => {
                                        if (
                                          Object.keys(prev).length ===
                                          formatTherapeuticData.length
                                        ) {
                                          // If all are selected, clear all
                                          setValue(
                                            "provider_therapeutic_areas",
                                            [],
                                          );
                                          setValue("provider_indications", []);
                                          return {};
                                        } else {
                                          // Otherwise, select all
                                          const newState =
                                            formatTherapeuticData.reduce(
                                              (
                                                acc,
                                                {
                                                  therapeuticArea,
                                                  indications,
                                                  therapeuticAreaId,
                                                  indicationIds,
                                                },
                                              ) => {
                                                // Create formatted indication objects for each indication
                                                const formattedIndications =
                                                  indications.map((ind) => ({
                                                    indication: ind,
                                                    indication_id:
                                                      indicationIds[ind],
                                                  }));

                                                return {
                                                  ...acc,
                                                  [therapeuticArea]: {
                                                    indications:
                                                      formattedIndications,
                                                    therapeuticAreaId:
                                                      therapeuticAreaId,
                                                    indicationIds:
                                                      indicationIds,
                                                  },
                                                  // provider_locations will be attached below (primary + additionals)
                                                };
                                              },
                                              {},
                                            );

                                          // Update form values
                                          const formattedTAs = Object.entries(
                                            newState,
                                          ).map(([ta, data]) => ({
                                            value: data.therapeuticAreaId,
                                            label: ta,
                                          }));

                                          const formattedIndications = [];
                                          Object.entries(newState).forEach(
                                            ([ta, data]) => {
                                              data.indications.forEach(
                                                (ind) => {
                                                  const indicationId =
                                                    typeof ind === "object"
                                                      ? ind.indication_id
                                                      : data.indicationIds[ind];

                                                  if (indicationId) {
                                                    formattedIndications.push({
                                                      value: indicationId,
                                                      label:
                                                        typeof ind === "object"
                                                          ? ind.indication
                                                          : ind,
                                                    });
                                                  }
                                                },
                                              );
                                            },
                                          );

                                          setValue(
                                            "provider_therapeutic_areas",
                                            formattedTAs,
                                          );
                                          setValue(
                                            "provider_indications",
                                            formattedIndications,
                                          );

                                          return newState;
                                        }
                                      });
                                    }}
                                  >
                                    <span
                                      className={`block truncate ${Object.keys(selectedTAIndications)
                                        .length ===
                                        formatTherapeuticData.length
                                        ? "font-semibold"
                                        : "font-normal"
                                        }`}
                                    >
                                      All Therapeutic Areas & Indications
                                    </span>
                                    {Object.keys(selectedTAIndications)
                                      .length ===
                                      formatTherapeuticData.length && (
                                        <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-white">
                                          <CheckIcon
                                            className="h-5 w-5"
                                            aria-hidden="true"
                                          />
                                        </span>
                                      )}
                                  </div>
                                </div>
                                {/* Existing therapeutic areas */}
                                {formatTherapeuticData.map(
                                  ({ therapeuticArea, indications }) => (
                                    <div
                                      key={therapeuticArea}
                                      className="relative"
                                    >
                                      <div
                                        className={`relative cursor-pointer select-none py-2 pl-6 pr-9 ${selectedTAIndications[therapeuticArea]
                                          ? "bg-indigo-600 text-white"
                                          : "text-gray-900 hover:bg-indigo-600 hover:text-white"
                                          }`}
                                      >
                                        <div className="flex items-center justify-between">
                                          <div
                                            className="flex-grow cursor-pointer flex items-center"
                                            onClick={(e) =>
                                              handleTASelection(
                                                therapeuticArea,
                                                indications,
                                                formatTherapeuticData.find(
                                                  (t) =>
                                                    t.therapeuticArea ===
                                                    therapeuticArea,
                                                )?.therapeuticAreaId,
                                                e,
                                              )
                                            }
                                          >
                                            <span
                                              className={`block truncate ${selectedTAIndications[
                                                therapeuticArea
                                              ]
                                                ? "font-semibold"
                                                : "font-normal"
                                                }`}
                                            >
                                              {therapeuticArea}
                                            </span>
                                            <div
                                              className="ml-2"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                toggleTAExpansion(
                                                  therapeuticArea,
                                                );
                                              }}
                                            >
                                              <svg
                                                className={`h-5 w-5 text-gray-400 transform transition-transform duration-200 ${expandedTAs.includes(
                                                  therapeuticArea,
                                                )
                                                  ? "rotate-180"
                                                  : ""
                                                  }`}
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                                aria-hidden="true"
                                              >
                                                <path d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" />
                                              </svg>
                                            </div>
                                          </div>
                                          {selectedTAIndications[
                                            therapeuticArea
                                          ] && (
                                              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-white">
                                                <CheckIcon
                                                  className="h-5 w-5"
                                                  aria-hidden="true"
                                                />
                                              </span>
                                            )}
                                        </div>
                                      </div>
                                      {expandedTAs.includes(
                                        therapeuticArea,
                                      ) && (
                                          <div>
                                            {indications.map((indication) => (
                                              <div
                                                key={indication}
                                                className={`cursor-pointer select-none py-2 pl-12 pr-9 relative ${selectedTAIndications[
                                                  therapeuticArea
                                                ]?.indications?.some((ind) =>
                                                  typeof ind === "object"
                                                    ? ind.indication ===
                                                    indication
                                                    : ind === indication,
                                                )
                                                  ? "bg-indigo-600 text-white"
                                                  : "text-gray-900 hover:bg-indigo-600 hover:text-white"
                                                  }`}
                                                onClick={(e) =>
                                                  handleIndicationSelection(
                                                    therapeuticArea,
                                                    {
                                                      indication: indication,
                                                      indication_id:
                                                        formatTherapeuticData.find(
                                                          (t) =>
                                                            t.therapeuticArea ===
                                                            therapeuticArea,
                                                        )?.indicationIds[
                                                        indication
                                                        ],
                                                    },
                                                    formatTherapeuticData.find(
                                                      (t) =>
                                                        t.therapeuticArea ===
                                                        therapeuticArea,
                                                    )?.therapeuticAreaId,
                                                    e,
                                                  )
                                                }
                                              >
                                                <span
                                                  className={`block truncate ${selectedTAIndications[
                                                    therapeuticArea
                                                  ]?.indications?.some((ind) =>
                                                    typeof ind === "object"
                                                      ? ind.indication ===
                                                      indication
                                                      : ind === indication,
                                                  )
                                                    ? "font-semibold"
                                                    : "font-normal"
                                                    }`}
                                                >
                                                  {indication}
                                                </span>
                                                {selectedTAIndications[
                                                  therapeuticArea
                                                ]?.indications?.some((ind) =>
                                                  typeof ind === "object"
                                                    ? ind.indication ===
                                                    indication
                                                    : ind === indication,
                                                ) && (
                                                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-white">
                                                      <CheckIcon
                                                        className="h-5 w-5"
                                                        aria-hidden="true"
                                                      />
                                                    </span>
                                                  )}
                                              </div>
                                            ))}
                                          </div>
                                        )}
                                    </div>
                                  ),
                                )}
                              </div>
                            )}
                            {formSubmitted &&
                              errors.provider_therapeutic_areas && (
                                <p className="mt-1 text-sm text-red-600">
                                  {errors.provider_therapeutic_areas.message}
                                </p>
                              )}
                          </div>
                        ) : field.type === "multi" &&
                          field.name ===
                          "provider_indications" ? null : field.type === "multi" &&
                          field.name === "provider_capabilities" ? (
                          <div className="flex flex-col">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              {field.label}{" "}
                              {field.required && (
                                <span className="text-red-600">*</span>
                              )}
                            </label>
                            <Controller
                              name="provider_capabilities"
                              control={control}
                              rules={{
                                required: field.required
                                  ? `${field.label} is required`
                                  : false,
                              }}
                              render={({ field: rhfField, fieldState: { error } }) => (
                                <>
                                  <ServiceCategoryV2Dropdown
                                    rfiList={rfis || []}
                                    placeholder={field.placeholder}
                                    selected={mergeLibrarySelected(
                                      rhfField.value || []
                                    )}
                                    onChange={(next) =>
                                      rhfField.onChange(mergeLibrarySelected(next))
                                    }
                                    lockedValues={libraryLockedValues}
                                    lockedLabels={libraryLockedLabels}
                                  />
                                  {error && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {error.message}
                                    </p>
                                  )}
                                </>
                              )}
                            />
                          </div>
                        ) : field.type === // Skip rendering the indications selector separately since it's handled in the TA dropdown
                            "multi" ? (
                          <FormMultiSelect
                            placeholder={field.placeholder}
                            key={field.name}
                            label={field.label}
                            name={field.name}
                            control={control}
                            required={field.required}
                            conditionallyRequired={field.conditionallyRequired}
                            watchFn={watch}
                            showErrors={formSubmitted}
                            options={
                              field.name === "provider_indications"
                                ? mapToOptions(threupatic, "id", "indication")
                                : field.name === "provider_therapeutic_areas"
                                  ? mapToOptions(
                                    therapeutics,
                                    "id",
                                    "therapeutic_area",
                                  )
                                  : field.name === "provider_capabilities" ||
                                    field.name ===
                                    "service_categories_secondary_location" ||
                                    field.name ===
                                    "service_categories_additional_locations"
                                    ? mapToOptions(rfis, "rfi_id", "rfi_name")
                                    : field.name ===
                                      "provider_geographic_regions"
                                      ? mapToOptions(
                                        geographicRegionData,
                                        "geographic_region_id",
                                        "geographic_region",
                                      )
                                      : field.name ===
                                        "provider_diversity_classifications"
                                        ? mapToOptions(
                                          diversityClassificationData,
                                          "diversity_classification_id",
                                          "diversity_classification",
                                        )
                                        : field.name ===
                                          "provider_affiliated_organizations"
                                          ? mapToOptions(
                                            affiliatedOrganizationData,
                                            "affiliated_organization_id",
                                            "affiliated_organization_name",
                                          )
                                          : field.name ===
                                            "provider_certifications"
                                            ? mapToOptions(
                                              certificationsData,
                                              "certification_id",
                                              "certification_name",
                                            )
                                            : field.name ===
                                              "provider_languages"
                                              ? mapToOptions(
                                                languagesData,
                                                "language_id",
                                                "language_name",
                                              )
                                              : []
                            }
                            colorize={field.name === "provider_capabilities"}
                          />
                        ) : field.type === "creatable-multi" ? (
                          <FormMultiSelect
                            key={field.name}
                            label={field.label}
                            name={field.name}
                            control={control}
                            required={field.required}
                            conditionallyRequired={field.conditionallyRequired}
                            watchFn={watch}
                            isCreatable={true}
                            placeholder={field.placeholder}
                          />
                        ) : field.type === "locationFields" ? (
                          <>
                            <label className="block text-sm font-medium text-gray-900 mb-1">
                              {field.label}{" "}
                              {field.required && (
                                <span className="text-red-600">*</span>
                              )}
                            </label>
                            <LocationFields
                              fullWidth
                              control={control}
                              errors={errors}
                              handleOnLoad={handleOnLoad}
                              handlePlaceChanged={handlePlaceChanged}
                              address={primaryAddress}
                              setAddress={setPrimaryAddress}
                              setValue={setValue}
                              onChangeLocation={syncPrimaryLocationDisplayFields}
                              city={primaryCity}
                              setCity={setPrimaryCity}
                              state={primaryState}
                              setState={setPrimaryState}
                              country={primaryCountry}
                              setCountry={setPrimaryCountry}
                              countrySearch={primaryCountrySearch}
                              setCountrySearch={setPrimaryCountrySearch}
                              isCountryDropdownOpen={
                                isPrimaryCountryDropdownOpen
                              }
                              setIsCountryDropdownOpen={
                                setIsPrimaryCountryDropdownOpen
                              }
                              isStateDropdownOpen={isPrimaryStateDropdownOpen}
                              setIsStateDropdownOpen={
                                setIsPrimaryStateDropdownOpen
                              }
                              stateSearch={primaryStateSearch}
                              setStateSearch={setPrimaryStateSearch}
                            />
                            {/* Additional locations section: vendor only; primary location is rendered above in locationFields */}
                            {isVendorView && (
                              <div className="col-span-full mt-6 pt-6 border-t border-gray-100">
                                {normalizeProviderLocations(additionalLocationsList).map((loc, idx) => (
                                  <div
                                    key={idx}
                                    className={
                                      idx === 0
                                        ? "pb-4"
                                        : "pt-4 mt-4 border-t border-gray-100 pb-4"
                                    }
                                  >
                                    <div className="flex items-center justify-between">
                                      <label className="block text-sm font-medium text-gray-900 mb-1">{`Additional location ${idx + 1}`}</label>
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleRemoveAdditionalLocation(idx)
                                        }
                                        className="text-gray-400 hover:text-red-500 transition-colors"
                                        aria-label={`Remove additional location ${idx + 1}`}
                                      >
                                        <XMarkIcon className="h-4 w-4" />
                                      </button>
                                    </div>

                                    <LocationFields
                                      control={control}
                                      errors={errors}
                                      address={loc?.address ?? ""}
                                      setAddress={(val) =>
                                        handleUpdateAdditionalLocation(idx, {
                                          address: val,
                                        })
                                      }
                                      city={loc?.city ?? ""}
                                      setCity={(val) =>
                                        handleUpdateAdditionalLocation(idx, {
                                          city: val,
                                        })
                                      }
                                      state={loc?.state ?? ""}
                                      setState={(val) =>
                                        handleUpdateAdditionalLocation(idx, {
                                          state: val,
                                        })
                                      }
                                      country={loc?.country ?? ""}
                                      setCountry={(val) =>
                                        handleUpdateAdditionalLocation(idx, {
                                          country: val,
                                        })
                                      }
                                      setValue={setValue}
                                      onChangeLocation={(vals) =>
                                        handleUpdateAdditionalLocation(idx, {
                                          address: vals.address,
                                          city: vals.city,
                                          state: vals.state,
                                          country: vals.country,
                                        })
                                      }
                                      handleOnLoad={(instance) =>
                                        handleOnLoadAdditionalAtIndex(instance, idx)
                                      }
                                      handlePlaceChanged={() =>
                                        handlePlaceChangedAdditionalAtIndex(idx)
                                      }
                                      fullWidth
                                      fieldPrefix={`additional_${idx}_`}
                                    />
                                  </div>
                                ))}

                                <div className="border-t border-gray-100 pt-4 sm:col-span-2">
                                  <button
                                    type="button"
                                    onClick={handleAddAdditionalLocation}
                                    className="text-indigo-600 text-sm cursor-pointer hover:underline hover:text-indigo-700 focus:outline-none"
                                  >
                                    Add Additional Location
                                  </button>
                                </div>
                              </div>
                            )}
                          </>
                        ) : field.name ===
                          "are_additional_locations_available" ||
                          field.name ===
                          "are_service_categories_same_across_locations" ? (
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              {field.label}{" "}
                              {(parseInt(
                                watch("number_of_additional_locations") || 0,
                                10,
                              ) > 0 ||
                                (field.name ===
                                  "are_additional_locations_available" &&
                                  watch("additional_locations")?.trim() !==
                                  "")) && (
                                  <span className="text-red-600">*</span>
                                )}
                            </label>
                            <div className="mt-1">
                              {field.options.map((option) => (
                                <div
                                  key={option.name}
                                  className="flex items-center mb-2"
                                >
                                  <input
                                    type="radio"
                                    id={`${field.name}-${option.value}`}
                                    name={field.name}
                                    value={option.value.toString()}
                                    checked={
                                      watch(field.name)?.toString() ===
                                      option.value.toString()
                                    }
                                    {...register(field.name, {
                                      required:
                                        parseInt(
                                          watch(
                                            "number_of_additional_locations",
                                          ) || 0,
                                          10,
                                        ) > 0 ||
                                          (field.name ===
                                            "are_additional_locations_available" &&
                                            watch(
                                              "additional_locations",
                                            )?.trim() !== "")
                                          ? "Required if additional locations are inputted"
                                          : false,
                                      setValueAs: (value) => {
                                        // Convert string "true"/"false" to actual boolean
                                        if (value === "true") return true;
                                        if (value === "false") return false;
                                        return value;
                                      },
                                    })}
                                    className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
                                  />
                                  <label
                                    htmlFor={`${field.name}-${option.value}`}
                                    className="ml-2 block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    {option.name}
                                  </label>
                                </div>
                              ))}
                              {formSubmitted && errors[field.name] && (
                                <p className="mt-1 text-sm text-red-600">
                                  {errors[field.name].message}
                                </p>
                              )}
                            </div>
                          </div>
                        ) : field.type === "select" &&
                          field.name === "provider_type" ? (
                          <CompanyTypeSelect
                            label={field.label}
                            name={field.name}
                            control={control}
                            options={field.options}
                            placeholder={field.placeholder}
                            required={field.required}
                            showErrors={formSubmitted}
                            errors={errors}
                          />
                        ) : [
                            "url",
                            "linkedin_url",
                            "facebook_url",
                            "twitter_url",
                            "instagram_url",
                            "youtube_url",
                          ].includes(field.name) ? (
                          <div>
                            <label className="block text-sm font-medium text-gray-900 mb-1">
                              {field.label}{" "}
                              {field.required && (
                                <span className="text-red-600">*</span>
                              )}
                            </label>
                            <Controller
                              name={field.name}
                              control={control}
                              render={({ field: f }) => (
                                <HttpsUrlInputStandalone
                                  name={field.name}
                                  label=""
                                  placeholder={
                                    field.placeholder || "www.example.com"
                                  }
                                  value={f.value}
                                  onChange={f.onChange}
                                  onBlur={f.onBlur}
                                  errorMessage={
                                    formSubmitted && errors[field.name]?.message
                                  }
                                  disabled={field.disabled}
                                />
                              )}
                            />
                          </div>
                        ) : (
                          <FormInput
                            label={field.label}
                            name={field.name}
                            type={field.type}
                            privateInfoLabel={field.privateInfoLabel}
                            placeholder={field.placeholder}
                            options={field.options}
                            required={field.required}
                            register={register}
                            errors={errors}
                            disabled={field.disabled}
                            numeric={field.numeric}
                            control={control}
                            watch={watch}
                            showErrors={formSubmitted}
                            // Google Places props
                            autocompleteSecondary={autocompleteSecondary}
                            autocompleteAdditional={autocompleteAdditional}
                            handleOnLoadSecondary={handleOnLoadSecondary}
                            handleOnLoadAdditional={handleOnLoadAdditional}
                            setCoordinates={setCoordinates}
                          />
                        )}
                      </div>
                    </>
                  ));
                })()}
              </div>
            </form>

            </div>);
            if (activeTab === "users") return (
            <OrgTeamMembersPanel
              filterDefinitions={teamUserFilterDefinitions}
              filters={teamUserFilters}
              onFilterChange={handleTeamUserFilterChange}
              onClearFilters={handleClearTeamUserFilters}
              showClearFilters={hasTeamUserFilterChanges}
              onAddTeamMember={handleAddTeamMember}
              isLoading={isLoadingTeamUsers}
              columns={teamMemberColumns}
              data={usersList}
              actionMenuItems={teamMemberActionMenuItems}
              onRowClick={handleManageTeamMember}
              sortConfig={teamSortConfig}
              onSort={handleTeamSort}
              rowKey={isVendorView ? "provider_user_id" : "id"}
              emptyDescription={teamUsersEmptyDescription}
              isSearchActive={!!debouncedTeamSearchTerm || hasTeamUserFilterChanges}
              getRowClassName={(item) =>
                teamMemberRowClassName(item, {
                  isMe: isLoggedInTeamMember(item, user?.id, { isVendorView }),
                })
              }
              currentPage={usersCurrentPage}
              onPageChange={setUsersCurrentPage}
              totalPages={usersSummary?.total_pages ?? 1}
            />
            );
            if (activeTab === "documents" && mode !== "create") return (
            <OrgLibraryDocumentsTab
              orgType={isSponsorView ? "sponsor" : "vendor"}
              orgId={isSponsorView ? sponsorId : vendorId}
              isCatalogAdmin={isAdmin}
            />
            );
            if (activeTab === "notifications" && isSponsorView && !isVendorView && !!sponsorId && mode !== "create") return (
            <OrgNotificationsTab sponsorId={sponsorId} showVqqRecipients={currentOrg ? !currentOrg.is_vqa_only : false} />
            );
            if (activeTab === "settings" && isAdmin && mode !== "create") return (
            <section className="w-full bg-white shadow-sm rounded-lg">
              <div className="w-full px-4 sm:px-6 lg:px-8 pt-6 pb-4">
                <div className="flex justify-end">
                  {isSettingsEditMode ? (
                    <div className="flex gap-2">
                      <button
                        type="button"
                        onClick={handleSettingsCancel}
                        disabled={isSettingsSaving}
                        className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        onClick={handleSettingsSave}
                        disabled={isSettingsSaving}
                        className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50"
                      >
                        {settingsSaveLabel}
                      </button>
                    </div>
                  ) : (
                    <button
                      type="button"
                      onClick={handleSettingsEdit}
                      disabled={isSettingsSaving || !currentOrg}
                      className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50"
                    >
                      Edit Settings
                    </button>
                  )}
                </div>
              </div>
              <div className="p-6 pt-0">
                <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
                  <div className="pt-4 sm:col-span-2">
                    <dt className="text-sm font-semibold text-gray-900">Organization Permissions</dt>
                    <dd className="mt-1 text-sm text-gray-500">Control which platform features are available to this {isVendorView ? "vendor" : "sponsor"} organization.</dd>
                  </div>
                  <div className="pt-2 sm:col-span-2">
                    <dt className="text-xs font-semibold uppercase tracking-wide text-gray-500">Security</dt>
                  </div>
                  <div className="sm:col-span-2">
                    <dd>
                      <label className={settingsOptionClassName}>
                        <div className="flex h-6 shrink-0 items-center">
                          <div className="group grid size-4 grid-cols-1">
                            <input
                              id="org-setting-mfa"
                              type="checkbox"
                              checked={!!orgData.mfa_required_for_org}
                              readOnly={!isSettingsEditMode || isSettingsSaving}
                              onChange={() =>
                                isSettingsEditMode &&
                                !isSettingsSaving &&
                                setOrgData((prev) => ({
                                  ...prev,
                                  mfa_required_for_org: !prev.mfa_required_for_org,
                                }))
                              }
                              className="col-start-1 row-start-1 size-4 appearance-none rounded-sm border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            />
                            <svg
                              viewBox="0 0 16 16"
                              fill="white"
                              className="pointer-events-none col-start-1 row-start-1 size-4 opacity-0 group-has-[input:checked]:opacity-100"
                              aria-hidden
                            >
                              <path d="M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z" />
                            </svg>
                          </div>
                        </div>
                        <span className="text-sm/6 font-medium text-gray-900">Require MFA for this organization</span>
                      </label>
                    </dd>
                  </div>

                  {isSponsorView && (
                    <>
                      <div className="border-t border-gray-100 pt-6 mt-2 sm:col-span-2">
                        <dt className="text-sm font-semibold text-gray-900">Requests</dt>
                      </div>
                      <div className="sm:col-span-2">
                        <dd>
                          <label className={settingsOptionClassName}>
                            <div className="flex h-6 shrink-0 items-center">
                              <div className="group grid size-4 grid-cols-1">
                                <input
                                  id="org-setting-vqa-only"
                                  type="checkbox"
                                  checked={!!orgData.is_vqa_only}
                                  readOnly={!isSettingsEditMode || isSettingsSaving}
                                  onChange={() =>
                                    isSettingsEditMode &&
                                    !isSettingsSaving &&
                                    setOrgData((prev) => ({
                                      ...prev,
                                      is_vqa_only: !prev.is_vqa_only,
                                    }))
                                  }
                                  className="col-start-1 row-start-1 size-4 appearance-none rounded-sm border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                />
                                <svg
                                  viewBox="0 0 16 16"
                                  fill="white"
                                  className="pointer-events-none col-start-1 row-start-1 size-4 opacity-0 group-has-[input:checked]:opacity-100"
                                  aria-hidden
                                >
                                  <path d="M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z" />
                                </svg>
                              </div>
                            </div>
                            <span>
                              <span className="block text-sm/6 font-medium text-gray-900">VQA Only Organization</span>
                              <span className="block text-sm text-gray-500">
                                This organization only requests VQAs. Its users cannot request VQQs, and new users get no HyperComply account. Turning this off gives the organization a HyperComply organization, if it has none yet, and gives its users HyperComply accounts.
                              </span>
                            </span>
                          </label>
                        </dd>
                      </div>
                    </>
                  )}

                  <div className="border-t border-gray-100 pt-6 mt-2 sm:col-span-2">
                    <dt className="text-sm font-semibold text-gray-900">Features</dt>
                  </div>
                  {isVendorView && (
                    <VendorPreviewFullReportSetting
                      className={settingsOptionClassName}
                      checked={previewFullReport.draft}
                      disabled={!isSettingsEditMode || isSettingsSaving}
                      onToggle={() => previewFullReport.setDraft((value) => !value)}
                    />
                  )}
                  {isSponsorView && (
                    <>
                      {[
                        {
                          key: "trial_experience_enabled",
                          label: "Trial Experience Dashboard",
                        },
                        { key: "chat_diligent_enabled", label: "ChatDiligent" },
                      ].map((perm) => (
                        <div key={perm.key} className="sm:col-span-2">
                          <dd>
                            <label className={settingsOptionClassName}>
                              <div className="flex h-6 shrink-0 items-center">
                                <div className="group grid size-4 grid-cols-1">
                                  <input
                                    id={`org-setting-${perm.key}`}
                                    type="checkbox"
                                    checked={!!orgData[perm.key]}
                                    readOnly={!isSettingsEditMode || isSettingsSaving}
                                    onChange={() =>
                                      isSettingsEditMode &&
                                      !isSettingsSaving &&
                                      setOrgData((prev) => ({
                                        ...prev,
                                        [perm.key]: !prev[perm.key],
                                      }))
                                    }
                                    className="col-start-1 row-start-1 size-4 appearance-none rounded-sm border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                  />
                                  <svg
                                    viewBox="0 0 16 16"
                                    fill="white"
                                    className="pointer-events-none col-start-1 row-start-1 size-4 opacity-0 group-has-[input:checked]:opacity-100"
                                    aria-hidden
                                  >
                                    <path d="M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z" />
                                  </svg>
                                </div>
                              </div>
                              <span className="text-sm/6 font-medium text-gray-900">{perm.label}</span>
                            </label>
                          </dd>
                        </div>
                      ))}
                    </>
                  )}
                  <OrgRiskEntitlementsSection
                    orgData={orgData}
                    setOrgData={setOrgData}
                    isSettingsEditMode={isSettingsEditMode}
                    isSettingsSaving={isSettingsSaving}
                    isSponsorView={isSponsorView}
                  />
                </dl>
              </div>
            </section>
            );
            return null;
          })()}
        </div>
      </div>

      <ActivateOrDeactivateConfirmationModal
        open={activateDeactivateModal.open}
        onClose={closeActivateDeactivateModal}
        onConfirm={handleConfirmActivateDeactivateContact}
        type="user"
        isDeactivated={activateDeactivateModal.targetActive === true}
        entityName={activateDeactivateContactEntityName}
      />
    </div>
  );
};

export default VendorOrganizationForm;
